import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  Unit_instanceat14thlj150z as Unit_instance,
  contentEquals2jbsaphs7gxql as contentEquals,
  contentHashCode33l4yznfe2pz3 as contentHashCode,
  intArrayIterator15bt84fheeonh as intArrayIterator,
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  VOID7hggqo3abtya as VOID,
  contentEquals379bkuxwxaiqz as contentEquals_0,
  contentHashCode2dpr73siofp13 as contentHashCode_0,
  floatArrayIteratortsocm2kbztk as floatArrayIterator,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  toString1pkumu07cwy4m as toString,
  reverse2o3etdk6ug8y7 as reverse,
  copyOfq9pcgcgbldck as copyOf,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  isFloatArrayjjscnqphw92j as isFloatArray,
  createThis2j2avj17cvnv2 as createThis,
  takeg3iw3d2yd8b4 as take,
  equals2au1ep9vhcato as equals,
  KtList3hktaavzmj137 as KtList,
  isInterface3d6p8outrmvmk as isInterface,
  StringBuildermazzzhj6kkai as StringBuilder,
  _Char___init__impl__6a9atx367vrx0avsvbg as _Char___init__impl__6a9atx,
  Collection1k04j3hzsbod0 as Collection,
  isIntArrayeijsubfngq38 as isIntArray,
  copyOf3rutauicler23 as copyOf_0,
  IndexOutOfBoundsException1qfr429iumro0 as IndexOutOfBoundsException,
  take8rd02inxauy8 as take_0,
  copyOfgossjg6lh6js as copyOf_1,
  isDoubleArray1wyh4nyf7pjxn as isDoubleArray,
  takei63g8tyo7wy9 as take_1,
  asList2ho2pewtsfvv as asList,
  compareTo3ankvs086tmwq as compareTo,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  fillArrayVali8eppxapiek4 as fillArrayVal,
  isArray1hxjqtqy632bc as isArray,
  toSet2orjxp16sotqu as toSet,
  toList3jhuyej2anx2q as toList,
  ArrayList3it5z8td81qkl as ArrayList,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  to2cs3ny02qtbcb as to,
  KtMap140uvy3s5zad8 as KtMap,
  hashCodeq5arwsb9dgti as hashCode,
  MutableIterablez3x4ksk1fmrm as MutableIterable,
  AbstractMutableSetthfi6jds1k2h as AbstractMutableSet,
  LinkedHashSet2tkztfx86kyx2 as LinkedHashSet,
  toMutableSetjdpdbr9jsqq8 as toMutableSet,
  until1jbpn0z3f8lbg as until,
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  coerceAtMost322komnqp70ag as coerceAtMost,
  joinToString1cxrrlmo0chqs as joinToString,
  Iterable1y3qizuf89iou as Iterable,
  copyOf2ng0t8oizk6it as copyOf_2,
  toString30pk9tzaqopn as toString_0,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  FunctionAdapter3lcrrz3moet5b as FunctionAdapter,
  Comparator2b3maoeh98xtg as Comparator,
  reversed3cb5fwpceefdb as reversed,
  NotImplementedErrorfzlkpv14xxr8 as NotImplementedError,
  contentEqualsaf55p28mnw74 as contentEquals_1,
  contentHashCode2i020q5tbeh2s as contentHashCode_1,
  throwUninitializedPropertyAccessExceptionyynx7gkm73wd as throwUninitializedPropertyAccessException,
  toRawBits2035dtuolth0v as toRawBits,
  LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap,
  getOrNull1go7ef9ldk0df as getOrNull,
  step18s9qzr5xwxat as step,
  arrayCopytctsywo3h7gj as arrayCopy,
  round2mrvepag8eey0 as round,
  toList383f556t1dixk as toList_0,
} from './kotlin-kotlin-stdlib.mjs';
import {
  umod164hvijxhfi8p as umod,
  ilog2Ceil34a3ub1n8578t as ilog2Ceil,
  isAlmostEquals$default2ib7nwup21mfy as isAlmostEquals$default,
  roundDecimalPlaces1x32iuyd1l8m5 as roundDecimalPlaces,
  appendNice3hizhj9kone09 as appendNice,
  appendGenericArray5krccch8fjd0 as appendGenericArray,
} from './korlibs-math-core-root-korlibs-math-core.mjs';
import {
  listIterator247sl90ooi4qv as listIterator,
  DoubleList2honu8rif2roh as DoubleList,
  fastArrayListOf1rdodhrpn0q8y as fastArrayListOf,
  FastArrayListw5fr1wlp4slq as FastArrayList,
  Mixin3lmkm5hum2vdj as Mixin,
} from './korlibs-datastructure-core-root-korlibs-datastructure-core.mjs';
import {
  NonRecursiveLock2vf7fkhp857q as NonRecursiveLock,
  Lock5n7hh3dgcidl as Lock,
} from './korlibs-concurrent-root-korlibs-concurrent.mjs';
import {
  Vector2D378fe5rov8fgw as Vector2D,
  IDoubleVectorListoa05cse3he2p as IDoubleVectorList,
  IPointListz7raskb2mrxa as IPointList,
  isNotEmptyrwyeygz7izwg as isNotEmpty,
  isAlmostEquals2qd88bwpjj4z5 as isAlmostEquals,
  containsAll194lepx84fvib as containsAll,
  indexOf3tp8bzbv46hci as indexOf,
  iterator1sm8hwbj0nmg8 as iterator,
  listIteratorrk3szyua4uzm as listIterator_0,
  listIterator3ooh2yjav3kr9 as listIterator_1,
  subList2funs4qwcrhhq as subList,
} from './korlibs-math-vector-root-korlibs-math-vector.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class Companion {}
class IArray2 {}
function inside(x, y) {
  return x >= 0 && y >= 0 && x < this.m2i() && y < this.n2i();
}
function getAt(x, y) {
  return this.u2i(x, y) ? this.qx(indexOr(this, x, y)) : this.qx(0);
}
function asString() {
  var tmp = until(0, this.n2i());
  return joinToString(tmp, '\n', VOID, VOID, VOID, VOID, IArray2$asString$lambda(this));
}
class IntIArray2 {}
function get(x, y) {
  return this.p2i(indexOr(this, x, y));
}
function set(x, y, value) {
  return this.q2i(indexOr(this, x, y), value);
}
function getAt_0(idx) {
  return this.p2i(idx);
}
class IntArray2 {
  constructor(width, height, data) {
    this.j2i_1 = width;
    this.k2i_1 = height;
    this.l2i_1 = data;
    Companion_instance_4.o2i(this.m2i(), this.n2i(), this.l2i_1.length);
  }
  m2i() {
    return this.j2i_1;
  }
  n2i() {
    return this.k2i_1;
  }
  equals(other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    if (other instanceof IntArray2) {
      tmp_1 = this.m2i() === other.m2i();
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.n2i() === other.n2i();
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = contentEquals(this.l2i_1, other.l2i_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  p2i(idx) {
    // Inline function 'kotlin.collections.getOrElse' call
    var this_0 = this.l2i_1;
    // Inline function 'kotlin.contracts.contract' call
    var tmp;
    if (0 <= idx ? idx <= (this_0.length - 1 | 0) : false) {
      tmp = this_0[idx];
    } else {
      // Inline function 'korlibs.datastructure.IntArray2.getFast.<anonymous>' call
      tmp = this.l2i_1[0];
    }
    return tmp;
  }
  q2i(idx, value) {
    if (0 <= idx ? idx <= (this.l2i_1.length - 1 | 0) : false) {
      this.l2i_1[idx] = value;
    }
  }
  hashCode() {
    return (this.m2i() + this.n2i() | 0) + contentHashCode(this.l2i_1) | 0;
  }
  a1() {
    return intArrayIterator(this.l2i_1);
  }
  toString() {
    return this.r2i();
  }
}
class Companion_0 {}
class FloatIArray2 {}
function get_0(x, y) {
  return this.p2i(indexOr(this, x, y));
}
function set_0(x, y, value) {
  return this.y2i(indexOr(this, x, y), value);
}
function getAt_1(idx) {
  return this.p2i(idx);
}
class FloatArray2 {
  constructor(width, height, data) {
    this.v2i_1 = width;
    this.w2i_1 = height;
    this.x2i_1 = data;
    Companion_instance_4.o2i(this.m2i(), this.n2i(), this.x2i_1.length);
  }
  m2i() {
    return this.v2i_1;
  }
  n2i() {
    return this.w2i_1;
  }
  equals(other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    if (other instanceof FloatArray2) {
      tmp_1 = this.m2i() === other.m2i();
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.n2i() === other.n2i();
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = contentEquals_0(this.x2i_1, other.x2i_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  p2i(idx) {
    // Inline function 'kotlin.collections.getOrElse' call
    var this_0 = this.x2i_1;
    // Inline function 'kotlin.contracts.contract' call
    var tmp;
    if (0 <= idx ? idx <= (this_0.length - 1 | 0) : false) {
      tmp = this_0[idx];
    } else {
      // Inline function 'korlibs.datastructure.FloatArray2.getFast.<anonymous>' call
      tmp = 0.0;
    }
    return tmp;
  }
  y2i(idx, value) {
    if (0 <= idx ? idx <= (this.x2i_1.length - 1 | 0) : false) {
      this.x2i_1[idx] = value;
    }
  }
  hashCode() {
    return (this.m2i() + this.n2i() | 0) + contentHashCode_0(this.x2i_1) | 0;
  }
  a1() {
    return floatArrayIterator(this.x2i_1);
  }
  toString() {
    return this.r2i();
  }
}
class Companion_1 {}
class FloatArrayList {
  static c2j(capacity) {
    capacity = capacity === VOID ? 7 : capacity;
    var $this = createThis(this);
    var tmp = $this;
    var tmp_0 = new Float32Array(capacity);
    tmp.a2j_1 = isFloatArray(tmp_0) ? tmp_0 : THROW_CCE();
    $this.b2j_1 = 0;
    return $this;
  }
  ys(value) {
    ensure(this, value);
    this.b2j_1 = value;
  }
  e1() {
    return this.b2j_1;
  }
  static d2j(other) {
    var $this = this.c2j();
    $this.e2j(other);
    return $this;
  }
  h3() {
    this.b2j_1 = 0;
  }
  f2j(v0, v1, v2, v3) {
    ensure(this, 4);
    var tmp = this.a2j_1;
    var _unary__edvuaz = this.b2j_1;
    this.b2j_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = v0;
    var tmp_0 = this.a2j_1;
    var _unary__edvuaz_0 = this.b2j_1;
    this.b2j_1 = _unary__edvuaz_0 + 1 | 0;
    tmp_0[_unary__edvuaz_0] = v1;
    var tmp_1 = this.a2j_1;
    var _unary__edvuaz_1 = this.b2j_1;
    this.b2j_1 = _unary__edvuaz_1 + 1 | 0;
    tmp_1[_unary__edvuaz_1] = v2;
    var tmp_2 = this.a2j_1;
    var _unary__edvuaz_2 = this.b2j_1;
    this.b2j_1 = _unary__edvuaz_2 + 1 | 0;
    tmp_2[_unary__edvuaz_2] = v3;
  }
  g2j(values, offset, length) {
    ensure(this, length);
    var tmp = Memory_instance;
    tmp.h2j(isFloatArray(values) ? values : THROW_CCE(), offset, this.a2j_1, this.e1(), length);
    this.ys(this.e1() + length | 0);
  }
  e2j(values, offset, length, $super) {
    offset = offset === VOID ? 0 : offset;
    length = length === VOID ? values.length : length;
    var tmp;
    if ($super === VOID) {
      this.g2j(values, offset, length);
      tmp = Unit_instance;
    } else {
      tmp = $super.g2j.call(this, values, offset, length);
    }
    return tmp;
  }
  qx(index) {
    return this.a2j_1[index];
  }
  a1() {
    return this.i1(0);
  }
  i2j(element) {
    var inductionVariable = 0;
    var last = this.b2j_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (this.a2j_1[n] === element)
          return true;
      }
       while (inductionVariable < last);
    return false;
  }
  j2j(elements) {
    var _iterator__ex2g4s = elements.a1();
    while (_iterator__ex2g4s.b1()) {
      var e = _iterator__ex2g4s.c1();
      if (!this.i2j(e))
        return false;
    }
    return true;
  }
  x2(elements) {
    return this.j2j(elements);
  }
  g1() {
    return this.e1() === 0;
  }
  k2j() {
    return copyOf(this.a2j_1, this.b2j_1);
  }
  i1(index) {
    return take(this.a2j_1, this.b2j_1).i1(index);
  }
  hashCode() {
    return contentHashCode_2(this.a2j_1, 0, this.e1());
  }
  equals(other) {
    if (other instanceof FloatArrayList)
      return this.e1() === other.e1() && contentEquals_2(this.a2j_1, other.a2j_1, 0, this.e1());
    if (!(other == null) ? isInterface(other, KtList) : false)
      return equals(other, this);
    return false;
  }
  toString() {
    // Inline function 'kotlin.also' call
    var this_0 = StringBuilder.tb(2 + imul(5, this.e1()) | 0);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.FloatArrayList.toString.<anonymous>' call
    this_0.pb(_Char___init__impl__6a9atx(91));
    var inductionVariable = 0;
    var last = this.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(n === 0)) {
          this_0.ob(', ');
        }
        this_0.ug(this.qx(n));
      }
       while (inductionVariable < last);
    this_0.pb(_Char___init__impl__6a9atx(93));
    return this_0.toString();
  }
}
class Companion_2 {}
class IntArrayList {
  static n2j(capacity) {
    capacity = capacity === VOID ? 7 : capacity;
    var $this = createThis(this);
    var tmp = $this;
    var tmp_0 = new Int32Array(capacity);
    tmp.l2j_1 = isIntArray(tmp_0) ? tmp_0 : THROW_CCE();
    $this.m2j_1 = 0;
    return $this;
  }
  ys(value) {
    this.o2j(value);
    this.m2j_1 = value;
  }
  e1() {
    return this.m2j_1;
  }
  static p2j(other) {
    var $this = this.n2j();
    $this.q2j(other);
    return $this;
  }
  static r2j(other) {
    var $this = this.n2j();
    $this.s2j(other);
    return $this;
  }
  o2j(count) {
    if ((this.m2j_1 + count | 0) > this.l2j_1.length) {
      var tmp = this;
      var tmp_0 = this.l2j_1;
      // Inline function 'kotlin.math.max' call
      var a = this.m2j_1 + count | 0;
      var b = imul(this.l2j_1.length, 3);
      var tmp$ret$0 = Math.max(a, b);
      var tmp_1 = copyOf_0(tmp_0, tmp$ret$0);
      tmp.l2j_1 = isIntArray(tmp_1) ? tmp_1 : THROW_CCE();
    }
  }
  h3() {
    this.m2j_1 = 0;
  }
  t2j(v0) {
    this.o2j(1);
    var tmp = this.l2j_1;
    var _unary__edvuaz = this.m2j_1;
    this.m2j_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = v0;
  }
  u2j(v0, v1, v2, v3) {
    this.o2j(4);
    var tmp = this.l2j_1;
    var _unary__edvuaz = this.m2j_1;
    this.m2j_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = v0;
    var tmp_0 = this.l2j_1;
    var _unary__edvuaz_0 = this.m2j_1;
    this.m2j_1 = _unary__edvuaz_0 + 1 | 0;
    tmp_0[_unary__edvuaz_0] = v1;
    var tmp_1 = this.l2j_1;
    var _unary__edvuaz_1 = this.m2j_1;
    this.m2j_1 = _unary__edvuaz_1 + 1 | 0;
    tmp_1[_unary__edvuaz_1] = v2;
    var tmp_2 = this.l2j_1;
    var _unary__edvuaz_2 = this.m2j_1;
    this.m2j_1 = _unary__edvuaz_2 + 1 | 0;
    tmp_2[_unary__edvuaz_2] = v3;
  }
  v2j(v0, v1, v2, v3, v4, v5) {
    this.o2j(6);
    var tmp = this.l2j_1;
    var _unary__edvuaz = this.m2j_1;
    this.m2j_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = v0;
    var tmp_0 = this.l2j_1;
    var _unary__edvuaz_0 = this.m2j_1;
    this.m2j_1 = _unary__edvuaz_0 + 1 | 0;
    tmp_0[_unary__edvuaz_0] = v1;
    var tmp_1 = this.l2j_1;
    var _unary__edvuaz_1 = this.m2j_1;
    this.m2j_1 = _unary__edvuaz_1 + 1 | 0;
    tmp_1[_unary__edvuaz_1] = v2;
    var tmp_2 = this.l2j_1;
    var _unary__edvuaz_2 = this.m2j_1;
    this.m2j_1 = _unary__edvuaz_2 + 1 | 0;
    tmp_2[_unary__edvuaz_2] = v3;
    var tmp_3 = this.l2j_1;
    var _unary__edvuaz_3 = this.m2j_1;
    this.m2j_1 = _unary__edvuaz_3 + 1 | 0;
    tmp_3[_unary__edvuaz_3] = v4;
    var tmp_4 = this.l2j_1;
    var _unary__edvuaz_4 = this.m2j_1;
    this.m2j_1 = _unary__edvuaz_4 + 1 | 0;
    tmp_4[_unary__edvuaz_4] = v5;
  }
  w2j(value) {
    return this.t2j(value);
  }
  x2j(value) {
    return this.q2j(value);
  }
  y2j(values, offset, length) {
    this.o2j(length);
    var tmp = Memory_instance;
    tmp.z2j(isIntArray(values) ? values : THROW_CCE(), offset, this.l2j_1, this.e1(), length);
    this.ys(this.e1() + length | 0);
  }
  s2j(values, offset, length, $super) {
    offset = offset === VOID ? 0 : offset;
    length = length === VOID ? values.length : length;
    var tmp;
    if ($super === VOID) {
      this.y2j(values, offset, length);
      tmp = Unit_instance;
    } else {
      tmp = $super.y2j.call(this, values, offset, length);
    }
    return tmp;
  }
  q2j(values) {
    return this.y2j(values.l2j_1, 0, values.e1());
  }
  d1(index) {
    return this.l2j_1[index];
  }
  qx(index) {
    return this.l2j_1[index];
  }
  a2k(index, value) {
    if (index >= this.m2j_1) {
      this.o2j(index + 1 | 0);
      this.m2j_1 = index + 1 | 0;
    }
    this.l2j_1[index] = value;
  }
  a1() {
    return this.i1(0);
  }
  cp(element) {
    var inductionVariable = 0;
    var last = this.m2j_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (this.l2j_1[n] === element)
          return true;
      }
       while (inductionVariable < last);
    return false;
  }
  b2k(elements) {
    var _iterator__ex2g4s = elements.a1();
    while (_iterator__ex2g4s.b1()) {
      var e = _iterator__ex2g4s.c1();
      if (!this.cp(e))
        return false;
    }
    return true;
  }
  x2(elements) {
    return this.b2k(elements);
  }
  g1() {
    return this.e1() === 0;
  }
  o27() {
    return !(this.e1() === 0);
  }
  kk() {
    var tmp;
    if (this.g1()) {
      throw IndexOutOfBoundsException.be();
    } else {
      tmp = this.l2j_1[0];
    }
    return tmp;
  }
  c2k() {
    var tmp;
    if (this.g1()) {
      throw IndexOutOfBoundsException.be();
    } else {
      tmp = this.l2j_1[this.m2j_1 - 1 | 0];
    }
    return tmp;
  }
  d2k(index, value) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.IntArrayList.insertAt.<anonymous>' call
    this.o2j(1);
    if (this.o27()) {
      Memory_instance.z2j(this.l2j_1, index, this.l2j_1, index + 1 | 0, this.m2j_1 - index | 0);
    }
    this.l2j_1[index] = value;
    this.m2j_1 = this.m2j_1 + 1 | 0;
    return this;
  }
  e2k(indexA, indexB) {
    var l = this.qx(indexA);
    var r = this.qx(indexB);
    this.a2k(indexA, r);
    this.a2k(indexB, l);
  }
  l3(index) {
    return this.f2k(index, 1);
  }
  f2k(index, count) {
    if (index < 0 || index >= this.m2j_1 || (index + count | 0) > this.m2j_1)
      throw IndexOutOfBoundsException.be();
    var out = this.l2j_1[index];
    if (count > 0) {
      if (index < (this.m2j_1 - count | 0)) {
        Memory_instance.z2j(this.l2j_1, index + count | 0, this.l2j_1, index, (this.m2j_1 - index | 0) - count | 0);
      }
      this.m2j_1 = this.m2j_1 - count | 0;
    }
    return out;
  }
  g2k() {
    return copyOf_0(this.l2j_1, this.m2j_1);
  }
  i1(index) {
    return take_0(this.l2j_1, this.m2j_1).i1(index);
  }
  hashCode() {
    return contentHashCode_3(this.l2j_1, 0, this.e1());
  }
  equals(other) {
    if (other instanceof IntArrayList)
      return this.e1() === other.e1() && contentEquals_3(this.l2j_1, other.l2j_1, 0, this.e1());
    if (!(other == null) ? isInterface(other, KtList) : false)
      return equals(other, this);
    return false;
  }
  toString() {
    // Inline function 'kotlin.also' call
    var this_0 = StringBuilder.tb(2 + imul(5, this.e1()) | 0);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.IntArrayList.toString.<anonymous>' call
    this_0.pb(_Char___init__impl__6a9atx(91));
    var inductionVariable = 0;
    var last = this.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(n === 0)) {
          this_0.ob(', ');
        }
        this_0.sg(this.qx(n));
      }
       while (inductionVariable < last);
    this_0.pb(_Char___init__impl__6a9atx(93));
    return this_0.toString();
  }
}
class Companion_3 {}
class DoubleArrayList {
  static j2k(capacity) {
    capacity = capacity === VOID ? 7 : capacity;
    var $this = createThis(this);
    var tmp = $this;
    var tmp_0 = new Float64Array(capacity);
    tmp.h2k_1 = isDoubleArray(tmp_0) ? tmp_0 : THROW_CCE();
    $this.i2k_1 = 0;
    return $this;
  }
  ys(value) {
    ensure_0(this, value);
    this.i2k_1 = value;
  }
  e1() {
    return this.i2k_1;
  }
  static k2k(other) {
    var $this = this.j2k();
    $this.l2k(other);
    return $this;
  }
  static m2k(other) {
    var $this = this.j2k();
    $this.n2k(other);
    return $this;
  }
  h3() {
    this.i2k_1 = 0;
  }
  nz(v0) {
    ensure_0(this, 1);
    var tmp = this.h2k_1;
    var _unary__edvuaz = this.i2k_1;
    this.i2k_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = v0;
  }
  o2k(v0, v1) {
    ensure_0(this, 2);
    var tmp = this.h2k_1;
    var _unary__edvuaz = this.i2k_1;
    this.i2k_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = v0;
    var tmp_0 = this.h2k_1;
    var _unary__edvuaz_0 = this.i2k_1;
    this.i2k_1 = _unary__edvuaz_0 + 1 | 0;
    tmp_0[_unary__edvuaz_0] = v1;
  }
  p2k(v0, v1, v2, v3) {
    ensure_0(this, 4);
    var tmp = this.h2k_1;
    var _unary__edvuaz = this.i2k_1;
    this.i2k_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = v0;
    var tmp_0 = this.h2k_1;
    var _unary__edvuaz_0 = this.i2k_1;
    this.i2k_1 = _unary__edvuaz_0 + 1 | 0;
    tmp_0[_unary__edvuaz_0] = v1;
    var tmp_1 = this.h2k_1;
    var _unary__edvuaz_1 = this.i2k_1;
    this.i2k_1 = _unary__edvuaz_1 + 1 | 0;
    tmp_1[_unary__edvuaz_1] = v2;
    var tmp_2 = this.h2k_1;
    var _unary__edvuaz_2 = this.i2k_1;
    this.i2k_1 = _unary__edvuaz_2 + 1 | 0;
    tmp_2[_unary__edvuaz_2] = v3;
  }
  q2k(v0, v1, v2, v3, v4, v5) {
    ensure_0(this, 6);
    var tmp = this.h2k_1;
    var _unary__edvuaz = this.i2k_1;
    this.i2k_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = v0;
    var tmp_0 = this.h2k_1;
    var _unary__edvuaz_0 = this.i2k_1;
    this.i2k_1 = _unary__edvuaz_0 + 1 | 0;
    tmp_0[_unary__edvuaz_0] = v1;
    var tmp_1 = this.h2k_1;
    var _unary__edvuaz_1 = this.i2k_1;
    this.i2k_1 = _unary__edvuaz_1 + 1 | 0;
    tmp_1[_unary__edvuaz_1] = v2;
    var tmp_2 = this.h2k_1;
    var _unary__edvuaz_2 = this.i2k_1;
    this.i2k_1 = _unary__edvuaz_2 + 1 | 0;
    tmp_2[_unary__edvuaz_2] = v3;
    var tmp_3 = this.h2k_1;
    var _unary__edvuaz_3 = this.i2k_1;
    this.i2k_1 = _unary__edvuaz_3 + 1 | 0;
    tmp_3[_unary__edvuaz_3] = v4;
    var tmp_4 = this.h2k_1;
    var _unary__edvuaz_4 = this.i2k_1;
    this.i2k_1 = _unary__edvuaz_4 + 1 | 0;
    tmp_4[_unary__edvuaz_4] = v5;
  }
  r2k(value) {
    return this.nz(value);
  }
  s2k(value) {
    return this.l2k(value);
  }
  t2k(values, offset, length) {
    ensure_0(this, length);
    var tmp = Memory_instance;
    tmp.u2k(isDoubleArray(values) ? values : THROW_CCE(), offset, this.h2k_1, this.e1(), length);
    this.ys(this.e1() + length | 0);
  }
  n2k(values, offset, length, $super) {
    offset = offset === VOID ? 0 : offset;
    length = length === VOID ? values.length : length;
    var tmp;
    if ($super === VOID) {
      this.t2k(values, offset, length);
      tmp = Unit_instance;
    } else {
      tmp = $super.t2k.call(this, values, offset, length);
    }
    return tmp;
  }
  l2k(values) {
    return this.t2k(values.h2k_1, 0, values.e1());
  }
  d1(index) {
    return this.h2k_1[index];
  }
  qx(index) {
    return this.h2k_1[index];
  }
  v2k(index, value) {
    if (index >= this.i2k_1) {
      ensure_0(this, index + 1 | 0);
      this.i2k_1 = index + 1 | 0;
    }
    this.h2k_1[index] = value;
  }
  a1() {
    return this.i1(0);
  }
  w2k(element) {
    var inductionVariable = 0;
    var last = this.i2k_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (this.h2k_1[n] === element)
          return true;
      }
       while (inductionVariable < last);
    return false;
  }
  tx(elements) {
    var _iterator__ex2g4s = elements.a1();
    while (_iterator__ex2g4s.b1()) {
      var e = _iterator__ex2g4s.c1();
      if (!this.w2k(e))
        return false;
    }
    return true;
  }
  x2(elements) {
    return this.tx(elements);
  }
  g1() {
    return this.e1() === 0;
  }
  e2k(indexA, indexB) {
    var l = this.qx(indexA);
    var r = this.qx(indexB);
    this.v2k(indexA, r);
    this.v2k(indexB, l);
  }
  l3(index) {
    return this.f2k(index, 1);
  }
  f2k(index, count) {
    if (index < 0 || index >= this.i2k_1 || (index + count | 0) > this.i2k_1)
      throw IndexOutOfBoundsException.be();
    var out = this.h2k_1[index];
    if (count > 0) {
      if (index < (this.i2k_1 - count | 0)) {
        Memory_instance.u2k(this.h2k_1, index + count | 0, this.h2k_1, index, (this.i2k_1 - index | 0) - count | 0);
      }
      this.i2k_1 = this.i2k_1 - count | 0;
    }
    return out;
  }
  rx() {
    return copyOf_1(this.h2k_1, this.i2k_1);
  }
  i1(index) {
    return take_1(this.h2k_1, this.i2k_1).i1(index);
  }
  z2(fromIndex, toIndex) {
    // Inline function 'kotlin.collections.asList' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = this.h2k_1;
    return asList(tmp$ret$1).z2(fromIndex, toIndex);
  }
  sx() {
    return DoubleArrayList.k2k(this);
  }
  hashCode() {
    return contentHashCode_4(this.h2k_1, 0, this.e1());
  }
  equals(other) {
    if (other instanceof DoubleArrayList)
      return this.e1() === other.e1() && contentEquals_4(this.h2k_1, other.h2k_1, 0, this.e1());
    if (!(other == null) ? isInterface(other, KtList) : false)
      return equals(other, this);
    return false;
  }
  toString() {
    // Inline function 'kotlin.also' call
    var this_0 = StringBuilder.tb(2 + imul(5, this.e1()) | 0);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.DoubleArrayList.toString.<anonymous>' call
    this_0.pb(_Char___init__impl__6a9atx(91));
    var inductionVariable = 0;
    var last = this.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(n === 0)) {
          this_0.ob(', ');
        }
        this_0.vg(this.qx(n));
      }
       while (inductionVariable < last);
    this_0.pb(_Char___init__impl__6a9atx(93));
    return this_0.toString();
  }
}
class SortOps {
  c2l(subject, indexL, indexR) {
    var inductionVariable = indexR;
    var last = indexL + 1 | 0;
    if (last <= inductionVariable)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        this.b2l(subject, n - 1 | 0, n);
      }
       while (!(n === last));
  }
  x2k(subject, indexL, indexR) {
    var count = (indexR - indexL | 0) + 1 | 0;
    var inductionVariable = 0;
    var last = count / 2 | 0;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.b2l(subject, indexL + n | 0, indexR - n | 0);
      }
       while (inductionVariable < last);
  }
}
class DoubleArrayListSortOps extends SortOps {
  constructor() {
    DoubleArrayListSortOps_instance = null;
    super();
    DoubleArrayListSortOps_instance = this;
  }
  y2k(subject, l, r) {
    return compareTo(subject.qx(l), subject.qx(r));
  }
  z2k(subject, l, r) {
    return this.y2k(subject instanceof DoubleArrayList ? subject : THROW_CCE(), l, r);
  }
  a2l(subject, indexL, indexR) {
    var l = subject.qx(indexL);
    var r = subject.qx(indexR);
    subject.v2k(indexR, l);
    subject.v2k(indexL, r);
  }
  b2l(subject, indexL, indexR) {
    return this.a2l(subject instanceof DoubleArrayList ? subject : THROW_CCE(), indexL, indexR);
  }
}
class TGenDeque$iterator$1 {
  constructor($that, this$0) {
    this.i2l_1 = $that;
    this.j2l_1 = this$0;
    this.h2l_1 = 0;
  }
  c1() {
    var _unary__edvuaz = this.h2l_1;
    this.h2l_1 = _unary__edvuaz + 1 | 0;
    return this.i2l_1.d1(_unary__edvuaz);
  }
  b1() {
    return this.h2l_1 < this.j2l_1.e1();
  }
  g6() {
    this.h2l_1 = this.h2l_1 - 1 | 0;
    this.j2l_1.l3(this.h2l_1);
  }
}
class TGenDeque {
  static k2l(initialCapacity) {
    var $this = createThis(this);
    $this.d2l_1 = 0;
    $this.e2l_1 = 0;
    var tmp = $this;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_0 = fillArrayVal(Array(initialCapacity), null);
    tmp.f2l_1 = isArray(tmp_0) ? tmp_0 : THROW_CCE();
    return $this;
  }
  static l2l() {
    return this.k2l(16);
  }
  e1() {
    return this.e2l_1;
  }
  g1() {
    return this.e1() === 0;
  }
  m2l(item) {
    resizeIfRequiredFor(this, 1);
    _addLast(this, item);
  }
  n2l(item) {
    resizeIfRequiredFor(this, 1);
    this.d2l_1 = umod(this.d2l_1 - 1 | 0, _get_capacity__a9k9f3(this));
    this.e2l_1 = this.e2l_1 + 1 | 0;
    this.f2l_1[this.d2l_1] = item;
  }
  o2l(list) {
    // Inline function 'korlibs.datastructure.TGenDeque._addAll' call
    var count = list.e1();
    resizeIfRequiredFor(this, count);
    var base = this.d2l_1 + this.e2l_1 | 0;
    var inductionVariable = 0;
    if (inductionVariable < count)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = this.f2l_1;
        var tmp_0 = (base + n | 0) % _get_capacity__a9k9f3(this) | 0;
        // Inline function 'korlibs.datastructure.TGenDeque.addAll.<anonymous>' call
        tmp[tmp_0] = list.d1(n);
      }
       while (inductionVariable < count);
    this.e2l_1 = this.e2l_1 + count | 0;
    return true;
  }
  p2l(elements) {
    return this.o2l(toList(elements));
  }
  f1(elements) {
    return this.p2l(elements);
  }
  q2l(items) {
    // Inline function 'korlibs.datastructure.TGenDeque._addAllFirst' call
    var count = items.e1();
    resizeIfRequiredFor(this, count);
    this.d2l_1 = umod(this.d2l_1 - count | 0, _get_capacity__a9k9f3(this));
    this.e2l_1 = this.e2l_1 + count | 0;
    var pos = this.d2l_1;
    var inductionVariable = 0;
    if (inductionVariable < count)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = this.f2l_1;
        var _unary__edvuaz = pos;
        pos = _unary__edvuaz + 1 | 0;
        var tmp_0 = umod(_unary__edvuaz, _get_capacity__a9k9f3(this));
        // Inline function 'korlibs.datastructure.TGenDeque.addAllFirst.<anonymous>' call
        tmp[tmp_0] = items.d1(n);
      }
       while (inductionVariable < count);
    return true;
  }
  nk() {
    if (this.e2l_1 <= 0)
      throw IndexOutOfBoundsException.be();
    var out = this.r2l();
    nullify(this, this.d2l_1);
    this.d2l_1 = (this.d2l_1 + 1 | 0) % _get_capacity__a9k9f3(this) | 0;
    this.e2l_1 = this.e2l_1 - 1 | 0;
    return out;
  }
  pk() {
    if (this.e2l_1 <= 0)
      throw IndexOutOfBoundsException.be();
    var out = this.s2l();
    nullify(this, internalIndex(this, this.e1() - 1 | 0));
    this.e2l_1 = this.e2l_1 - 1 | 0;
    return out;
  }
  l3(index) {
    if (index < 0 || index >= this.e1())
      throw IndexOutOfBoundsException.be();
    if (index === 0)
      return this.nk();
    if (index === (this.e1() - 1 | 0))
      return this.pk();
    var old = this.d1(index);
    if (index < (this.e1() / 2 | 0)) {
      var inductionVariable = index;
      if (1 <= inductionVariable)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + -1 | 0;
          this.t2l(n, this.d1(n - 1 | 0));
        }
         while (1 <= inductionVariable);
      this.d2l_1 = umod(this.d2l_1 + 1 | 0, _get_capacity__a9k9f3(this));
    } else {
      var inductionVariable_0 = index;
      var last = this.e1() - 1 | 0;
      if (inductionVariable_0 < last)
        do {
          var n_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          this.t2l(n_0, this.d1(n_0 + 1 | 0));
        }
         while (inductionVariable_0 < last);
    }
    this.e2l_1 = this.e2l_1 - 1 | 0;
    return old;
  }
  u2l(element) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.TGenDeque.add.<anonymous>' call
    this.m2l(element);
    return true;
  }
  h(element) {
    return this.u2l((element == null ? true : !(element == null)) ? element : THROW_CCE());
  }
  h3() {
    this.e2l_1 = 0;
  }
  v2l(element) {
    var index = this.w2l(element);
    if (index >= 0) {
      this.l3(index);
    }
    return index >= 0;
  }
  j3(element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.v2l((element == null ? true : !(element == null)) ? element : THROW_CCE());
  }
  x2l(elements) {
    return _removeRetainAll(this, elements, false);
  }
  r2l() {
    return this.f2l_1[this.d2l_1];
  }
  s2l() {
    return this.f2l_1[internalIndex(this, this.e1() - 1 | 0)];
  }
  t2l(index, value) {
    this.f2l_1[internalIndex(this, index)] = value;
  }
  d1(index) {
    return this.f2l_1[internalIndex(this, index)];
  }
  y2l(index) {
    return (0 <= index ? index <= (this.e1() - 1 | 0) : false) ? this.d1(index) : null;
  }
  w2l(element) {
    var inductionVariable = 0;
    var last = this.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (equals(this.d1(n), element))
          return n;
      }
       while (inductionVariable < last);
    return -1;
  }
  z2l(elements) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(elements, 10));
    var tmp0_iterator = elements.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.datastructure.TGenDeque.containsAll.<anonymous>' call
      var tmp$ret$0 = to(item, 0);
      destination.h(tmp$ret$0);
    }
    var emap = toLinkedMap(destination);
    var inductionVariable = 0;
    var last = this.e1();
    if (inductionVariable < last)
      do {
        var it = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var e = this.d1(it);
        // Inline function 'kotlin.collections.contains' call
        // Inline function 'kotlin.collections.containsKey' call
        if ((isInterface(emap, KtMap) ? emap : THROW_CCE()).a3(e)) {
          // Inline function 'kotlin.collections.set' call
          emap.e3(e, 1);
        }
      }
       while (inductionVariable < last);
    var tmp$ret$5;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var this_0 = emap.i3();
      var tmp;
      if (isInterface(this_0, Collection)) {
        tmp = this_0.g1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$5 = true;
        break $l$block_0;
      }
      var tmp0_iterator_0 = this_0.a1();
      while (tmp0_iterator_0.b1()) {
        var element = tmp0_iterator_0.c1();
        // Inline function 'korlibs.datastructure.TGenDeque.containsAll.<anonymous>' call
        if (!(element === 1)) {
          tmp$ret$5 = false;
          break $l$block_0;
        }
      }
      tmp$ret$5 = true;
    }
    return tmp$ret$5;
  }
  x2(elements) {
    return this.z2l(elements);
  }
  a1() {
    var that = this;
    return new TGenDeque$iterator$1(that, this);
  }
  hashCode() {
    // Inline function 'korlibs.datastructure.internal.contentHashCode' call
    var size = this.e1();
    var result = 1;
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = imul(31, result);
        // Inline function 'kotlin.hashCode' call
        // Inline function 'korlibs.datastructure.TGenDeque.hashCode.<anonymous>' call
        var tmp0_safe_receiver = this.d1(n);
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
        result = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
      }
       while (inductionVariable < size);
    return result;
  }
  equals(other) {
    if (!(other instanceof TGenDeque))
      return false;
    if (!(other.e1() === this.e1()))
      return false;
    var inductionVariable = 0;
    var last = this.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!equals(this.d1(n), other.d1(n)))
          return false;
      }
       while (inductionVariable < last);
    return true;
  }
  toString() {
    var sb = StringBuilder.f();
    sb.pb(_Char___init__impl__6a9atx(91));
    var inductionVariable = 0;
    var last = this.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        sb.nb(this.d1(n));
        if (!(n === (this.e1() - 1 | 0))) {
          sb.ob(', ');
        }
      }
       while (inductionVariable < last);
    sb.pb(_Char___init__impl__6a9atx(93));
    return sb.toString();
  }
}
class IntDeque$iterator$1 {
  constructor($that, this$0) {
    this.e2m_1 = $that;
    this.f2m_1 = this$0;
    this.d2m_1 = 0;
  }
  c1() {
    var _unary__edvuaz = this.d2m_1;
    this.d2m_1 = _unary__edvuaz + 1 | 0;
    return this.e2m_1.d1(_unary__edvuaz);
  }
  b1() {
    return this.d2m_1 < this.f2m_1.e1();
  }
  g6() {
    this.d2m_1 = this.d2m_1 - 1 | 0;
    this.f2m_1.l3(this.d2m_1);
  }
}
class IntDeque {
  static g2m(initialCapacity) {
    var $this = createThis(this);
    $this.a2m_1 = 0;
    $this.b2m_1 = 0;
    var tmp = $this;
    var tmp_0 = new Int32Array(initialCapacity);
    tmp.c2m_1 = isIntArray(tmp_0) ? tmp_0 : THROW_CCE();
    return $this;
  }
  static h2m() {
    return this.g2m(16);
  }
  e1() {
    return this.b2m_1;
  }
  g1() {
    return this.e1() === 0;
  }
  i2m(item) {
    resizeIfRequiredFor_0(this, 1);
    _addLast_0(this, item);
  }
  j2m(list) {
    // Inline function 'korlibs.datastructure.IntDeque._addAll' call
    var count = list.e1();
    resizeIfRequiredFor_0(this, count);
    var base = this.a2m_1 + this.b2m_1 | 0;
    var inductionVariable = 0;
    if (inductionVariable < count)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = this.c2m_1;
        var tmp_0 = (base + n | 0) % _get_capacity__a9k9f3_0(this) | 0;
        // Inline function 'korlibs.datastructure.IntDeque.addAll.<anonymous>' call
        tmp[tmp_0] = list.d1(n);
      }
       while (inductionVariable < count);
    this.b2m_1 = this.b2m_1 + count | 0;
    return true;
  }
  k2m(elements) {
    return this.j2m(toList(elements));
  }
  f1(elements) {
    return this.k2m(elements);
  }
  nk() {
    if (this.b2m_1 <= 0)
      throw IndexOutOfBoundsException.be();
    var out = this.r2l();
    nullify_0(this, this.a2m_1);
    this.a2m_1 = (this.a2m_1 + 1 | 0) % _get_capacity__a9k9f3_0(this) | 0;
    this.b2m_1 = this.b2m_1 - 1 | 0;
    return out;
  }
  pk() {
    if (this.b2m_1 <= 0)
      throw IndexOutOfBoundsException.be();
    var out = this.s2l();
    nullify_0(this, internalIndex_0(this, this.e1() - 1 | 0));
    this.b2m_1 = this.b2m_1 - 1 | 0;
    return out;
  }
  l3(index) {
    if (index < 0 || index >= this.e1())
      throw IndexOutOfBoundsException.be();
    if (index === 0)
      return this.nk();
    if (index === (this.e1() - 1 | 0))
      return this.pk();
    var old = this.d1(index);
    if (index < (this.e1() / 2 | 0)) {
      var inductionVariable = index;
      if (1 <= inductionVariable)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + -1 | 0;
          this.a2k(n, this.d1(n - 1 | 0));
        }
         while (1 <= inductionVariable);
      this.a2m_1 = umod(this.a2m_1 + 1 | 0, _get_capacity__a9k9f3_0(this));
    } else {
      var inductionVariable_0 = index;
      var last = this.e1() - 1 | 0;
      if (inductionVariable_0 < last)
        do {
          var n_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          this.a2k(n_0, this.d1(n_0 + 1 | 0));
        }
         while (inductionVariable_0 < last);
    }
    this.b2m_1 = this.b2m_1 - 1 | 0;
    return old;
  }
  l2m(element) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.IntDeque.add.<anonymous>' call
    this.i2m(element);
    return true;
  }
  h(element) {
    return this.l2m((!(element == null) ? typeof element === 'number' : false) ? element : THROW_CCE());
  }
  m2m(element) {
    var index = this.n2m(element);
    if (index >= 0) {
      this.l3(index);
    }
    return index >= 0;
  }
  j3(element) {
    if (!(!(element == null) ? typeof element === 'number' : false))
      return false;
    return this.m2m((!(element == null) ? typeof element === 'number' : false) ? element : THROW_CCE());
  }
  r2l() {
    return this.c2m_1[this.a2m_1];
  }
  s2l() {
    return this.c2m_1[internalIndex_0(this, this.e1() - 1 | 0)];
  }
  a2k(index, value) {
    this.c2m_1[internalIndex_0(this, index)] = value;
  }
  d1(index) {
    return this.c2m_1[internalIndex_0(this, index)];
  }
  n2m(element) {
    var inductionVariable = 0;
    var last = this.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (this.d1(n) === element)
          return n;
      }
       while (inductionVariable < last);
    return -1;
  }
  b2k(elements) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(elements, 10));
    var tmp0_iterator = elements.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.datastructure.IntDeque.containsAll.<anonymous>' call
      var tmp$ret$0 = to(item, 0);
      destination.h(tmp$ret$0);
    }
    var emap = toLinkedMap(destination);
    var inductionVariable = 0;
    var last = this.e1();
    if (inductionVariable < last)
      do {
        var it = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var e = this.d1(it);
        // Inline function 'kotlin.collections.contains' call
        // Inline function 'kotlin.collections.containsKey' call
        if ((isInterface(emap, KtMap) ? emap : THROW_CCE()).a3(e)) {
          // Inline function 'kotlin.collections.set' call
          emap.e3(e, 1);
        }
      }
       while (inductionVariable < last);
    var tmp$ret$5;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var this_0 = emap.i3();
      var tmp;
      if (isInterface(this_0, Collection)) {
        tmp = this_0.g1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$5 = true;
        break $l$block_0;
      }
      var tmp0_iterator_0 = this_0.a1();
      while (tmp0_iterator_0.b1()) {
        var element = tmp0_iterator_0.c1();
        // Inline function 'korlibs.datastructure.IntDeque.containsAll.<anonymous>' call
        if (!(element === 1)) {
          tmp$ret$5 = false;
          break $l$block_0;
        }
      }
      tmp$ret$5 = true;
    }
    return tmp$ret$5;
  }
  x2(elements) {
    return this.b2k(elements);
  }
  a1() {
    var that = this;
    return new IntDeque$iterator$1(that, this);
  }
  hashCode() {
    // Inline function 'korlibs.datastructure.internal.contentHashCode' call
    var size = this.e1();
    var result = 1;
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = imul(31, result);
        // Inline function 'kotlin.hashCode' call
        // Inline function 'korlibs.datastructure.IntDeque.hashCode.<anonymous>' call
        var tmp0_safe_receiver = this.d1(n);
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
        result = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
      }
       while (inductionVariable < size);
    return result;
  }
  equals(other) {
    if (!(other instanceof IntDeque))
      return false;
    if (!(other.e1() === this.e1()))
      return false;
    var inductionVariable = 0;
    var last = this.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(this.d1(n) === other.d1(n)))
          return false;
      }
       while (inductionVariable < last);
    return true;
  }
  toString() {
    var sb = StringBuilder.f();
    sb.pb(_Char___init__impl__6a9atx(91));
    var inductionVariable = 0;
    var last = this.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        sb.sg(this.d1(n));
        if (!(n === (this.e1() - 1 | 0))) {
          sb.ob(', ');
        }
      }
       while (inductionVariable < last);
    sb.pb(_Char___init__impl__6a9atx(93));
    return sb.toString();
  }
}
class FastSmallSet extends AbstractMutableSet {
  static s2m() {
    var $this = this.q7();
    $this.o2m_1 = LinkedHashSet.j1();
    $this.p2m_1 = null;
    $this.q2m_1 = null;
    $this.r2m_1 = null;
    return $this;
  }
  e1() {
    return this.o2m_1.e1();
  }
  a1() {
    return this.o2m_1.a1();
  }
  t2m(element) {
    if (this.wk(element))
      return false;
    this.o2m_1.h(element);
    return true;
  }
  h(element) {
    return this.t2m((element == null ? true : !(element == null)) ? element : THROW_CCE());
  }
  u2m(element) {
    this.p2m_1 = null;
    this.q2m_1 = null;
    this.r2m_1 = null;
    this.o2m_1.j3(element);
    return true;
  }
  j3(element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.u2m((element == null ? true : !(element == null)) ? element : THROW_CCE());
  }
  wk(element) {
    if (element === this.p2m_1 || element === this.q2m_1 || element === this.p2m_1)
      return true;
    var result = this.o2m_1.w2(element);
    if (result) {
      this.q2m_1 = this.p2m_1;
      this.r2m_1 = this.q2m_1;
      this.p2m_1 = element;
    }
    return result;
  }
  w2(element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.wk((element == null ? true : !(element == null)) ? element : THROW_CCE());
  }
  h3() {
    this.o2m_1.h3();
    this.p2m_1 = null;
    this.q2m_1 = null;
    this.r2m_1 = null;
  }
}
class GenericSubList {
  constructor(base, start, end) {
    this.v2m_1 = base;
    this.w2m_1 = start;
    this.x2m_1 = end;
    var containsUpper = this.v2m_1.e1();
    var containsArg = this.w2m_1;
    if (!(0 <= containsArg ? containsArg <= containsUpper : false))
      throw IndexOutOfBoundsException.ce('' + this.w2m_1);
    var containsUpper_0 = this.v2m_1.e1();
    var containsArg_0 = this.x2m_1;
    if (!(0 <= containsArg_0 ? containsArg_0 <= containsUpper_0 : false))
      throw IndexOutOfBoundsException.ce('' + this.x2m_1);
  }
  e1() {
    return this.x2m_1 - this.w2m_1 | 0;
  }
  xk(elements) {
    var elementsSet = toMutableSet(elements);
    var inductionVariable = 0;
    var last = this.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.collections.minusAssign' call
        var element = this.d1(n);
        elementsSet.j3(element);
      }
       while (inductionVariable < last);
    return elementsSet.g1();
  }
  x2(elements) {
    return this.xk(elements);
  }
  d1(index) {
    return this.v2m_1.d1(translateIndex(index, this));
  }
  y2m(element) {
    var inductionVariable = 0;
    var last = this.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (equals(this.d1(n), element))
          return n;
      }
       while (inductionVariable < last);
    return -1;
  }
  l1(element) {
    if (!(element == null ? true : !(element == null)))
      return -1;
    return this.y2m((element == null ? true : !(element == null)) ? element : THROW_CCE());
  }
  g1() {
    return this.e1() === 0;
  }
  a1() {
    return new GenericListIterator(this);
  }
  y2() {
    return new GenericListIterator(this);
  }
  i1(index) {
    return new GenericListIterator(this, index);
  }
  z2(fromIndex, toIndex) {
    return new GenericSubList(this, fromIndex, toIndex);
  }
  toString() {
    // Inline function 'kotlin.collections.map' call
    var this_0 = until(0, this.e1());
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var inductionVariable = this_0.a2_1;
    var last = this_0.b2_1;
    if (inductionVariable <= last)
      do {
        var item = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.datastructure.GenericSubList.toString.<anonymous>' call
        var it = item;
        var tmp$ret$0 = this.d1(it);
        destination.h(tmp$ret$0);
      }
       while (!(item === last));
    return toString(destination);
  }
  equals(other) {
    var tmp;
    if (other instanceof GenericSubList) {
      var tmp$ret$1;
      $l$block: {
        // Inline function 'korlibs.datastructure.internal.equaler' call
        var count = this.e1();
        var inductionVariable = 0;
        if (inductionVariable < count)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'korlibs.datastructure.GenericSubList.equals.<anonymous>' call
            if (!equals(this.d1(n), other.d1(n))) {
              tmp$ret$1 = false;
              break $l$block;
            }
          }
           while (inductionVariable < count);
        tmp$ret$1 = true;
      }
      tmp = tmp$ret$1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    // Inline function 'korlibs.datastructure.internal.hashCoder' call
    var count = this.e1();
    var out = 0;
    var inductionVariable = 0;
    if (inductionVariable < count)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        out = imul(out, 7);
        var tmp = out;
        // Inline function 'korlibs.datastructure.GenericSubList.hashCode.<anonymous>' call
        // Inline function 'kotlin.hashCode' call
        var tmp0_safe_receiver = this.d1(n);
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
        out = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
      }
       while (inductionVariable < count);
    return out;
  }
}
class GenericListIterator {
  constructor(list, iindex) {
    iindex = iindex === VOID ? 0 : iindex;
    this.z2m_1 = list;
    this.a2n_1 = iindex;
    var containsUpper = this.z2m_1.e1();
    var containsArg = this.a2n_1;
    if (!(0 <= containsArg ? containsArg < containsUpper : false))
      throw IndexOutOfBoundsException.ce('' + this.a2n_1);
    this.b2n_1 = this.a2n_1;
  }
  b1() {
    return this.b2n_1 < this.z2m_1.e1();
  }
  c1() {
    if (!this.b1())
      throw NoSuchElementException.k6();
    var _unary__edvuaz = this.b2n_1;
    this.b2n_1 = _unary__edvuaz + 1 | 0;
    return this.z2m_1.d1(_unary__edvuaz);
  }
  equals(other) {
    var tmp;
    var tmp_0;
    if (other instanceof GenericListIterator) {
      tmp_0 = equals(this.z2m_1, other.z2m_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.b2n_1 === other.b2n_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.z2m_1) + this.b2n_1 | 0;
  }
}
class HistoryStack {
  constructor(maxLength, initialCapacity) {
    maxLength = maxLength === VOID ? 2147483637 : maxLength;
    initialCapacity = initialCapacity === VOID ? 7 : initialCapacity;
    this.c2n_1 = maxLength;
    this.d2n_1 = TGenDeque.k2l(initialCapacity);
    this.e2n_1 = 0;
  }
  f2n(value) {
    $l$loop: while (true) {
      var tmp;
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!this.d2n_1.g1()) {
        tmp = this.d2n_1.e1() > this.e2n_1;
      } else {
        tmp = false;
      }
      if (!tmp) {
        break $l$loop;
      }
      this.d2n_1.pk();
    }
    this.d2n_1.u2l(value);
    this.e2n_1 = this.d2n_1.e1();
    $l$loop_0: while (true) {
      var tmp_0;
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!this.d2n_1.g1()) {
        tmp_0 = this.d2n_1.e1() > this.c2n_1;
      } else {
        tmp_0 = false;
      }
      if (!tmp_0) {
        break $l$loop_0;
      }
      this.d2n_1.nk();
      this.e2n_1 = this.e2n_1 - 1 | 0;
    }
  }
  g2n() {
    this.e2n_1 = coerceAtLeast(this.e2n_1 - 1 | 0, 0);
    return this.d2n_1.y2l(this.e2n_1 - 1 | 0);
  }
  h2n() {
    // Inline function 'kotlin.also' call
    var this_0 = this.d2n_1.y2l(this.e2n_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.HistoryStack.redo.<anonymous>' call
    this.e2n_1 = coerceAtMost(this.e2n_1 + 1 | 0, this.d2n_1.e1() + 1 | 0);
    return this_0;
  }
}
class Companion_4 {
  o2i(width, height, arraySize) {
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(arraySize >= imul(width, height))) {
      // Inline function 'korlibs.datastructure.Companion.checkArraySize.<anonymous>' call
      var message = 'backing array of size=' + arraySize + ', has less elements than ' + width + ' * ' + height;
      throw IllegalStateException.w4(toString(message));
    }
  }
}
class Companion_5 {
  constructor() {
    this.y2n_1 = 2147483646;
    this.z2n_1 = 2147483647;
    this.a2o_1 = 0;
  }
}
class Entry {
  constructor(key, value) {
    this.e2o_1 = key;
    this.f2o_1 = value;
  }
  toString() {
    return 'Entry(key=' + this.e2o_1 + ', value=' + toString_0(this.f2o_1) + ')';
  }
  hashCode() {
    var result = this.e2o_1;
    result = imul(result, 31) + (this.f2o_1 == null ? 0 : hashCode(this.f2o_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Entry))
      return false;
    var tmp0_other_with_cast = other instanceof Entry ? other : THROW_CCE();
    if (!(this.e2o_1 === tmp0_other_with_cast.e2o_1))
      return false;
    if (!equals(this.f2o_1, tmp0_other_with_cast.f2o_1))
      return false;
    return true;
  }
}
class Iterator {
  constructor(map) {
    this.i2n_1 = map;
    this.j2n_1 = this.i2n_1.o2n_1 ? 2147483647 : nextNonEmptyIndex(this, this.i2n_1.s2n_1, 0);
    this.k2n_1 = new Entry(0, null);
  }
  b1() {
    return !(this.j2n_1 === 2147483646);
  }
  w2n() {
    // Inline function 'kotlin.apply' call
    var this_0 = currentKey(this);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.Iterator.nextKey.<anonymous>' call
    next(this);
    return this_0;
  }
  x2n() {
    // Inline function 'kotlin.apply' call
    var this_0 = currentValue(this);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.Iterator.nextValue.<anonymous>' call
    next(this);
    return this_0;
  }
}
class _no_name_provided__qut3iv {
  constructor(this$0) {
    this.g2o_1 = this$0;
  }
  a1() {
    // Inline function 'korlibs.datastructure.IntMap.<get-keys>.<anonymous>' call
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.IntMap.<get-keys>.<anonymous>.<anonymous>' call
    var it = new Iterator(this.g2o_1);
    var tmp = IntMap$_get_keys_$o$iterator$lambda_bn8atq(it);
    return Iterator_0(tmp, IntMap$_get_keys_$o$iterator$lambda_bn8atq_0(it));
  }
}
class _no_name_provided__qut3iv_0 {
  constructor(this$0) {
    this.h2o_1 = this$0;
  }
  a1() {
    // Inline function 'korlibs.datastructure.IntMap.<get-values>.<anonymous>' call
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.IntMap.<get-values>.<anonymous>.<anonymous>' call
    var it = new Iterator(this.h2o_1);
    var tmp = IntMap$_get_values_$o$iterator$lambda_ggo058(it);
    return Iterator_0(tmp, IntMap$_get_values_$o$iterator$lambda_ggo058_0(it));
  }
}
class IntMap {
  static b2o(nbits, loadFactor, dummy) {
    dummy = dummy === VOID ? false : dummy;
    var $this = createThis(this);
    $this.l2n_1 = nbits;
    $this.m2n_1 = loadFactor;
    $this.n2n_1 = 1 << $this.l2n_1;
    $this.o2n_1 = false;
    $this.p2n_1 = null;
    $this.q2n_1 = $this.n2n_1 - 1 | 0;
    $this.r2n_1 = 1 + imul($this.l2n_1, $this.l2n_1) | 0;
    $this.s2n_1 = new Int32Array($this.d2o());
    var tmp = $this;
    // Inline function 'kotlin.arrayOfNulls' call
    var size = $this.d2o();
    var tmp_0 = fillArrayVal(Array(size), null);
    tmp.t2n_1 = isArray(tmp_0) ? tmp_0 : THROW_CCE();
    $this.u2n_1 = numberToInt($this.n2n_1 * $this.m2n_1);
    $this.v2n_1 = 0;
    return $this;
  }
  static i2o(initialCapacity, loadFactor) {
    initialCapacity = initialCapacity === VOID ? 16 : initialCapacity;
    loadFactor = loadFactor === VOID ? 0.75 : loadFactor;
    // Inline function 'kotlin.math.max' call
    var b = ilog2Ceil(initialCapacity);
    var tmp$ret$0 = Math.max(4, b);
    return this.b2o(tmp$ret$0, loadFactor, true);
  }
  d2o() {
    return this.n2n_1 + this.r2n_1 | 0;
  }
  d1(key) {
    var index = _getKeyIndex(this, key);
    if (index < 0)
      return null;
    if (index === 2147483647)
      return this.p2n_1;
    return this.t2n_1[index];
  }
  c2o(key, value) {
    retry: while (true) {
      var index = _getKeyIndex(this, key);
      if (index < 0) {
        if (key === 0) {
          this.o2n_1 = true;
          this.p2n_1 = value;
          this.v2n_1 = this.v2n_1 + 1 | 0;
          return null;
        }
        if (this.v2n_1 >= this.u2n_1) {
          grow(this);
        }
        var index1 = hash1(this, key);
        if (this.s2n_1[index1] === 0)
          return setEmptySlot(this, index1, key, value);
        var index2 = hash2(this, key);
        if (this.s2n_1[index2] === 0)
          return setEmptySlot(this, index2, key, value);
        var index3 = hash3(this, key);
        if (this.s2n_1[index3] === 0)
          return setEmptySlot(this, index3, key, value);
        var inductionVariable = _get_stashStart__3psegu(this);
        var last = this.s2n_1.length;
        if (inductionVariable < last)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            if (this.s2n_1[n] === 0)
              return setEmptySlot(this, n, key, value);
          }
           while (inductionVariable < last);
        if (this.r2n_1 > 512) {
          grow(this);
        } else {
          growStash(this);
        }
        continue retry;
      } else if (index === 2147483647) {
        // Inline function 'kotlin.apply' call
        var this_0 = this.p2n_1;
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.datastructure.IntMap.set.<anonymous>' call
        this.p2n_1 = value;
        return this_0;
      } else {
        // Inline function 'kotlin.apply' call
        var this_1 = this.t2n_1[index];
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.datastructure.IntMap.set.<anonymous>' call
        this.t2n_1[index] = value;
        return this_1;
      }
    }
  }
  d3() {
    // Inline function 'kotlin.collections.Iterable' call
    return new _no_name_provided__qut3iv(this);
  }
  i3() {
    // Inline function 'kotlin.collections.Iterable' call
    return new _no_name_provided__qut3iv_0(this);
  }
  j2o(keys, offset) {
    var inductionVariable = offset;
    var last = keys.length;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(keys[n] === 0))
          return n;
      }
       while (inductionVariable < last);
    return 2147483646;
  }
  equals(other) {
    if (!(other instanceof IntMap))
      return false;
    // Inline function 'korlibs.datastructure.IntMap.fastForEachNullable' call
    // Inline function 'korlibs.datastructure.IntMap.fastKeyForEach' call
    var index = this.o2n_1 ? 2147483647 : this.j2o(this.s2n_1, 0);
    while (!(index === 2147483646)) {
      // Inline function 'korlibs.datastructure.IntMap.fastForEachNullable.<anonymous>' call
      var it;
      switch (index) {
        case 2147483647:
        case 2147483646:
          it = 0;
          break;
        default:
          it = this.s2n_1[index];
          break;
      }
      // Inline function 'korlibs.datastructure.IntMap.equals.<anonymous>' call
      var key = it;
      var value = this.d1(it);
      if (!equals(other.d1(key), value))
        return false;
      index = this.j2o(this.s2n_1, index === 2147483647 ? 0 : index + 1 | 0);
    }
    return true;
  }
  hashCode() {
    var out = 0;
    // Inline function 'korlibs.datastructure.IntMap.fastForEachNullable' call
    // Inline function 'korlibs.datastructure.IntMap.fastKeyForEach' call
    var index = this.o2n_1 ? 2147483647 : this.j2o(this.s2n_1, 0);
    while (!(index === 2147483646)) {
      // Inline function 'korlibs.datastructure.IntMap.fastForEachNullable.<anonymous>' call
      var it;
      switch (index) {
        case 2147483647:
        case 2147483646:
          it = 0;
          break;
        default:
          it = this.s2n_1[index];
          break;
      }
      // Inline function 'korlibs.datastructure.IntMap.hashCode.<anonymous>' call
      var tmp = out;
      var tmp_0 = it;
      // Inline function 'kotlin.hashCode' call
      var tmp0_safe_receiver = this.d1(it);
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
      out = tmp + (tmp_0 + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0) | 0;
      index = this.j2o(this.s2n_1, index === 2147483647 ? 0 : index + 1 | 0);
    }
    return out;
  }
}
class Companion_6 {
  constructor() {
    this.k2o_1 = 2147483646;
    this.l2o_1 = 2147483647;
    this.m2o_1 = 0;
  }
}
class IntIntMap {
  static y2o(nbits, loadFactor, dummy) {
    var $this = createThis(this);
    $this.n2o_1 = nbits;
    $this.o2o_1 = loadFactor;
    $this.p2o_1 = 1 << $this.n2o_1;
    $this.q2o_1 = false;
    $this.r2o_1 = 0;
    $this.s2o_1 = $this.p2o_1 - 1 | 0;
    $this.t2o_1 = 1 + imul($this.n2o_1, $this.n2o_1) | 0;
    $this.u2o_1 = new Int32Array($this.d2o());
    $this.v2o_1 = new Int32Array($this.d2o());
    $this.w2o_1 = numberToInt($this.p2o_1 * $this.o2o_1);
    $this.x2o_1 = 0;
    return $this;
  }
  static a2p(initialCapacity, loadFactor) {
    initialCapacity = initialCapacity === VOID ? 16 : initialCapacity;
    loadFactor = loadFactor === VOID ? 0.75 : loadFactor;
    // Inline function 'kotlin.math.max' call
    var b = ilog2Ceil(initialCapacity);
    var tmp$ret$0 = Math.max(4, b);
    return this.y2o(tmp$ret$0, loadFactor, true);
  }
  toString() {
    return toString(this.b2p());
  }
  d2o() {
    return this.p2o_1 + this.t2o_1 | 0;
  }
  c2p(out) {
    // Inline function 'korlibs.datastructure.IntIntMap.fastForEach' call
    // Inline function 'korlibs.datastructure.IntIntMap.fastKeyForEach' call
    var index = this.q2o_1 ? 2147483647 : this.j2o(this.u2o_1, 0);
    while (!(index === 2147483646)) {
      // Inline function 'korlibs.datastructure.IntIntMap.fastForEach.<anonymous>' call
      var it;
      switch (index) {
        case 2147483647:
        case 2147483646:
          it = 0;
          break;
        default:
          it = this.u2o_1[index];
          break;
      }
      // Inline function 'korlibs.datastructure.IntIntMap.toMap.<anonymous>' call
      var key = it;
      // Inline function 'kotlin.collections.set' call
      var value = this.d1(it);
      out.e3(key, value);
      index = this.j2o(this.u2o_1, index === 2147483647 ? 0 : index + 1 | 0);
    }
    return out;
  }
  b2p(out, $super) {
    out = out === VOID ? linkedHashMapOf([]) : out;
    return $super === VOID ? this.c2p(out) : $super.c2p.call(this, out);
  }
  cp(key) {
    return _getKeyIndex_0(this, key) >= 0;
  }
  h3() {
    this.q2o_1 = false;
    this.r2o_1 = 0;
    fill(this.u2o_1, 0);
    fill(this.v2o_1, 0);
    this.x2o_1 = 0;
  }
  d1(key) {
    var index = _getKeyIndex_0(this, key);
    if (index < 0)
      return 0;
    if (index === 2147483647)
      return this.r2o_1;
    return this.v2o_1[index];
  }
  z2o(key, value) {
    retry: while (true) {
      var index = _getKeyIndex_0(this, key);
      if (index < 0) {
        if (key === 0) {
          this.q2o_1 = true;
          this.r2o_1 = value;
          this.x2o_1 = this.x2o_1 + 1 | 0;
          return 0;
        }
        if (this.x2o_1 >= this.w2o_1) {
          grow_0(this);
        }
        var index1 = hash1_0(this, key);
        if (this.u2o_1[index1] === 0)
          return setEmptySlot_0(this, index1, key, value);
        var index2 = hash2_0(this, key);
        if (this.u2o_1[index2] === 0)
          return setEmptySlot_0(this, index2, key, value);
        var index3 = hash3_0(this, key);
        if (this.u2o_1[index3] === 0)
          return setEmptySlot_0(this, index3, key, value);
        var inductionVariable = _get_stashStart__3psegu_0(this);
        var last = this.u2o_1.length;
        if (inductionVariable < last)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            if (this.u2o_1[n] === 0)
              return setEmptySlot_0(this, n, key, value);
          }
           while (inductionVariable < last);
        if (this.t2o_1 > 512) {
          grow_0(this);
        } else {
          growStash_0(this);
        }
        continue retry;
      } else if (index === 2147483647) {
        // Inline function 'kotlin.apply' call
        var this_0 = this.r2o_1;
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.datastructure.IntIntMap.set.<anonymous>' call
        this.r2o_1 = value;
        return this_0;
      } else {
        // Inline function 'kotlin.apply' call
        var this_1 = this.v2o_1[index];
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.datastructure.IntIntMap.set.<anonymous>' call
        this.v2o_1[index] = value;
        return this_1;
      }
    }
  }
  j2o(keys, offset) {
    var inductionVariable = offset;
    var last = keys.length;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(keys[n] === 0))
          return n;
      }
       while (inductionVariable < last);
    return 2147483646;
  }
  equals(other) {
    if (!(other instanceof IntIntMap))
      return false;
    // Inline function 'korlibs.datastructure.IntIntMap.fastForEach' call
    // Inline function 'korlibs.datastructure.IntIntMap.fastKeyForEach' call
    var index = this.q2o_1 ? 2147483647 : this.j2o(this.u2o_1, 0);
    while (!(index === 2147483646)) {
      // Inline function 'korlibs.datastructure.IntIntMap.fastForEach.<anonymous>' call
      var it;
      switch (index) {
        case 2147483647:
        case 2147483646:
          it = 0;
          break;
        default:
          it = this.u2o_1[index];
          break;
      }
      // Inline function 'korlibs.datastructure.IntIntMap.equals.<anonymous>' call
      var key = it;
      var value = this.d1(it);
      if (!(other.d1(key) === value))
        return false;
      index = this.j2o(this.u2o_1, index === 2147483647 ? 0 : index + 1 | 0);
    }
    return true;
  }
  hashCode() {
    var out = 0;
    // Inline function 'korlibs.datastructure.IntIntMap.fastForEach' call
    // Inline function 'korlibs.datastructure.IntIntMap.fastKeyForEach' call
    var index = this.q2o_1 ? 2147483647 : this.j2o(this.u2o_1, 0);
    while (!(index === 2147483646)) {
      // Inline function 'korlibs.datastructure.IntIntMap.fastForEach.<anonymous>' call
      var it;
      switch (index) {
        case 2147483647:
        case 2147483646:
          it = 0;
          break;
        default:
          it = this.u2o_1[index];
          break;
      }
      // Inline function 'korlibs.datastructure.IntIntMap.hashCode.<anonymous>' call
      out = out + (it + this.d1(it) | 0) | 0;
      index = this.j2o(this.u2o_1, index === 2147483647 ? 0 : index + 1 | 0);
    }
    return out;
  }
}
class Iterator$1 {
  constructor($hasNext, $next) {
    this.d2p_1 = $hasNext;
    this.e2p_1 = $next;
  }
  b1() {
    return this.d2p_1();
  }
  c1() {
    return this.e2p_1();
  }
}
class Companion_7 {}
class Pool {
  static j2p(reset, preallocate, gen) {
    var tmp;
    if (reset === VOID) {
      tmp = Pool$_init_$lambda_q3cbhr;
    } else {
      tmp = reset;
    }
    reset = tmp;
    preallocate = preallocate === VOID ? 0 : preallocate;
    var $this = createThis(this);
    $this.f2p_1 = reset;
    $this.g2p_1 = gen;
    $this.h2p_1 = _TGenStack___init__impl__yynjgt();
    $this.i2p_1 = 0;
    var inductionVariable = 0;
    if (inductionVariable < preallocate)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var _unary__edvuaz = $this.i2p_1;
        $this.i2p_1 = _unary__edvuaz + 1 | 0;
        TGenStack__push_impl_9yh33t($this.h2p_1, $this.g2p_1(_unary__edvuaz));
      }
       while (inductionVariable < preallocate);
    return $this;
  }
  static k2p(preallocate, gen) {
    preallocate = preallocate === VOID ? 0 : preallocate;
    return this.j2p(Pool$_init_$lambda_q3cbhr_0, preallocate, gen);
  }
  l2p() {
    return _TGenStack___get_size__impl__cvg66t(this.h2p_1);
  }
  m2p() {
    var tmp;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!(new TGenStack(this.h2p_1)).g1()) {
      tmp = TGenStack__pop_impl_qisxa0(this.h2p_1);
    } else {
      var _unary__edvuaz = this.i2p_1;
      this.i2p_1 = _unary__edvuaz + 1 | 0;
      tmp = this.g2p_1(_unary__edvuaz);
    }
    return tmp;
  }
  h3() {
    TGenStack__clear_impl_pali4s(this.h2p_1);
    this.i2p_1 = 0;
  }
  n2p(element) {
    this.f2p_1(element);
    TGenStack__push_impl_9yh33t(this.h2p_1, element);
  }
  o2p(elements) {
    var _iterator__ex2g4s = elements.a1();
    while (_iterator__ex2g4s.b1()) {
      var element = _iterator__ex2g4s.c1();
      this.n2p(element);
    }
  }
  hashCode() {
    return TGenStack__hashCode_impl_l04zom(this.h2p_1);
  }
  equals(other) {
    var tmp;
    var tmp_0;
    if (other instanceof Pool) {
      tmp_0 = equals(this.h2p_1, other.h2p_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.l2p() === other.l2p();
    } else {
      tmp = false;
    }
    return tmp;
  }
}
class ConcurrentPool extends Pool {
  static w2p(reset, preallocate, gen) {
    var tmp;
    if (reset === VOID) {
      tmp = ConcurrentPool$_init_$lambda_gqhtk8;
    } else {
      tmp = reset;
    }
    reset = tmp;
    preallocate = preallocate === VOID ? 0 : preallocate;
    var $this = this.j2p(reset, preallocate, gen);
    $this.t2p_1 = reset;
    $this.u2p_1 = gen;
    $this.v2p_1 = new NonRecursiveLock();
    return $this;
  }
  m2p() {
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this.v2p_1.y1u_1;
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke.<anonymous>' call
    // Inline function 'korlibs.datastructure.ConcurrentPool.alloc.<anonymous>' call
    return super.m2p();
  }
  h3() {
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this.v2p_1.y1u_1;
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke.<anonymous>' call
    super.h3();
  }
  n2p(element) {
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this.v2p_1.y1u_1;
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke.<anonymous>' call
    super.n2p(element);
  }
}
class ReturnablePool {
  constructor(_reset, gen) {
    var tmp;
    if (_reset === VOID) {
      tmp = ReturnablePool$_init_$lambda_rsm60r;
    } else {
      tmp = _reset;
    }
    _reset = tmp;
    this.x2p_1 = _reset;
    this.y2p_1 = gen;
    this.z2p_1 = fastArrayListOf([]);
    var tmp_0 = this;
    var tmp_1 = ReturnablePool$list$lambda(this);
    tmp_0.a2q_1 = Pool.j2p(tmp_1, VOID, ReturnablePool$list$lambda_0(this));
    this.b2q_1 = this.a2q_1.m2p();
  }
  c1() {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.z2p_1;
    var element = this.b2q_1;
    this_0.h(element);
    this.b2q_1 = this.a2q_1.m2p();
    return this.b2q_1;
  }
  c2q() {
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = this.z2p_1.ly_1;
    var n = 0;
    while (n < array.length) {
      // Inline function 'korlibs.datastructure.ReturnablePool.reset.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      var it = array[_unary__edvuaz];
      this.a2q_1.n2p(it);
    }
    this.z2p_1.h3();
  }
}
class sam$kotlin_Comparator$0 {
  constructor(function_0) {
    this.d2q_1 = function_0;
  }
  ui(a, b) {
    return this.d2q_1(a, b);
  }
  compare(a, b) {
    return this.ui(a, b);
  }
  k4() {
    return this.d2q_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.k4(), other.k4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.k4());
  }
}
class Companion_8 {
  e2q(comparator, reversed_0) {
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp = fillArrayVal(Array(16), null);
    return new TGenPriorityQueue(isArray(tmp) ? tmp : THROW_CCE(), reversed_0 ? reversed(comparator) : comparator);
  }
  f2q(reversed, comparator) {
    return Companion_instance_8.e2q(new sam$kotlin_Comparator$0(comparator), reversed);
  }
  g2q(reversed, comparator, $super) {
    reversed = reversed === VOID ? false : reversed;
    return $super === VOID ? this.f2q(reversed, comparator) : $super.f2q.call(this, reversed, comparator);
  }
}
class TGenPriorityQueue$iterator$1 {
  constructor($index, this$0) {
    this.k2q_1 = $index;
    this.l2q_1 = this$0;
  }
  b1() {
    return this.k2q_1._v < this.l2q_1.j2q_1;
  }
  c1() {
    var _unary__edvuaz = this.k2q_1._v;
    this.k2q_1._v = _unary__edvuaz + 1 | 0;
    return _get_value__a43j40(_PriorityQueueNode___init__impl__34dlfu(_unary__edvuaz), this.l2q_1);
  }
  y1a() {
    throw NotImplementedError.od();
  }
  g6() {
    return this.y1a();
  }
}
class TGenPriorityQueue {
  constructor(data, comparator) {
    this.h2q_1 = data;
    this.i2q_1 = comparator;
    this.j2q_1 = 0;
  }
  e1() {
    return this.j2q_1;
  }
  m2q() {
    if (this.j2q_1 <= 0)
      throw IndexOutOfBoundsException.be();
    return this.h2q_1[0];
  }
  u2l(element) {
    this.j2q_1 = this.j2q_1 + 1 | 0;
    ensure_1(this, this.j2q_1);
    var i = _PriorityQueueNode___init__impl__34dlfu(this.j2q_1 - 1 | 0);
    _set_value__lx0xdg(i, this, element);
    while (!_get_isRoot__1006zj(i, this) && gt(this, _get_value__a43j40(_get_parent__oo9xup(i, this), this), _get_value__a43j40(i, this))) {
      swap_0(this, i, _get_parent__oo9xup(i, this));
      i = _get_parent__oo9xup(i, this);
    }
    return true;
  }
  h(element) {
    return this.u2l((element == null ? true : !(element == null)) ? element : THROW_CCE());
  }
  n2q() {
    if (this.j2q_1 <= 0)
      throw IndexOutOfBoundsException.be();
    if (this.j2q_1 === 1) {
      this.j2q_1 = this.j2q_1 - 1 | 0;
      return _get_value__a43j40(_PriorityQueueNode___init__impl__34dlfu(0), this);
    }
    var root = _get_value__a43j40(_PriorityQueueNode___init__impl__34dlfu(0), this);
    _set_value__lx0xdg(_PriorityQueueNode___init__impl__34dlfu(0), this, _get_value__a43j40(_PriorityQueueNode___init__impl__34dlfu(this.j2q_1 - 1 | 0), this));
    this.j2q_1 = this.j2q_1 - 1 | 0;
    minHeapify(this, 0);
    return root;
  }
  w2l(element) {
    var inductionVariable = 0;
    var last = this.j2q_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (equals(this.h2q_1[n], element))
          return n;
      }
       while (inductionVariable < last);
    return -1;
  }
  v2l(element) {
    var index = this.w2l(element);
    if (index >= 0) {
      this.o2q(index);
    }
    return index >= 0;
  }
  j3(element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.v2l((element == null ? true : !(element == null)) ? element : THROW_CCE());
  }
  o2q(index) {
    var i = _PriorityQueueNode___init__impl__34dlfu(index);
    while (!(_PriorityQueueNode___get_index__impl__b6r7i5(i) === 0)) {
      swap_0(this, i, _get_parent__oo9xup(i, this));
      i = _get_parent__oo9xup(i, this);
    }
    this.n2q();
  }
  z2l(elements) {
    var thisSet = toSet(this);
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp;
      if (isInterface(elements, Collection)) {
        tmp = elements.g1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var tmp0_iterator = elements.a1();
      while (tmp0_iterator.b1()) {
        var element = tmp0_iterator.c1();
        // Inline function 'korlibs.datastructure.TGenPriorityQueue.containsAll.<anonymous>' call
        if (!thisSet.w2(element)) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  }
  x2(elements) {
    return this.z2l(elements);
  }
  g1() {
    return this.j2q_1 === 0;
  }
  p2l(elements) {
    var _iterator__ex2g4s = elements.a1();
    while (_iterator__ex2g4s.b1()) {
      var e = _iterator__ex2g4s.c1();
      this.u2l(e);
    }
    // Inline function 'kotlin.collections.isNotEmpty' call
    return !elements.g1();
  }
  f1(elements) {
    return this.p2l(elements);
  }
  a1() {
    var index = {_v: 0};
    return new TGenPriorityQueue$iterator$1(index, this);
  }
  toString() {
    return toString(toList(this));
  }
  equals(other) {
    var tmp;
    var tmp_0;
    if (other instanceof TGenPriorityQueue) {
      tmp_0 = contentEquals_1(this.h2q_1, other.h2q_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = equals(this.i2q_1, other.i2q_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return contentHashCode_1(this.h2q_1);
  }
}
class TGenQueue {
  constructor() {
    this.p2q_1 = TGenDeque.l2l();
  }
  e1() {
    return this.p2q_1.e1();
  }
  g1() {
    return this.e1() === 0;
  }
  q2q(v) {
    this.p2q_1.m2l(v);
  }
  r2q() {
    return this.p2q_1.nk();
  }
  z2l(elements) {
    return this.p2q_1.z2l(elements);
  }
  x2(elements) {
    return this.z2l(elements);
  }
  a1() {
    return this.p2q_1.a1();
  }
  hashCode() {
    return this.p2q_1.hashCode();
  }
  equals(other) {
    var tmp;
    if (other instanceof TGenQueue) {
      tmp = this.p2q_1.equals(other.p2q_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
}
class Ref$1 {
  s2q(_set____db54di) {
    this.t2q_1 = _set____db54di;
  }
  r1() {
    var tmp = this.t2q_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('value');
    }
  }
}
class Ref$2 {
  constructor($prop) {
    this.u2q_1 = $prop;
  }
  s2q(value) {
    this.u2q_1.set(value);
  }
  r1() {
    return this.u2q_1.get();
  }
}
class Companion_9 {}
class TGenStack {
  constructor(items) {
    this.v2q_1 = items;
  }
  e1() {
    return _TGenStack___get_size__impl__cvg66t(this.v2q_1);
  }
  g1() {
    return TGenStack__isEmpty_impl_bsbpyi(this.v2q_1);
  }
  z2l(elements) {
    return TGenStack__containsAll_impl_ic9i7r(this.v2q_1, elements);
  }
  x2(elements) {
    return TGenStack__containsAll_impl_ic9i7r_0(this, elements);
  }
  a1() {
    return TGenStack__iterator_impl_2pdia5(this.v2q_1);
  }
  toString() {
    return TGenStack__toString_impl_s9t5hn(this.v2q_1);
  }
  hashCode() {
    return TGenStack__hashCode_impl_l04zom(this.v2q_1);
  }
  equals(other) {
    return TGenStack__equals_impl_w9i35u(this.v2q_1, other);
  }
}
class SyncPauseable {
  constructor() {
    this.w2q_1 = new Lock();
    this.x2q_1 = false;
  }
  y2q(value) {
    if (!(this.x2q_1 === value)) {
      this.x2q_1 = value;
      // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
      var this_0 = this.w2q_1;
      $l$block: {
        // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
        this_0.d1v();
        try {
          this.w2q_1.h1v();
          break $l$block;
        }finally {
          this_0.f1v();
        }
      }
    }
  }
}
class Memory {
  g2l(src, srcPos, dst, dstPos, size) {
    // Inline function 'kotlin.collections.copyInto' call
    var destination = isArray(dst) ? dst : THROW_CCE();
    var endIndex = srcPos + size | 0;
    arrayCopy(src, destination, dstPos, srcPos, endIndex);
  }
  z2j(src, srcPos, dst, dstPos, size) {
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex = srcPos + size | 0;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = src;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    arrayCopy(tmp, dst, dstPos, srcPos, endIndex);
  }
  h2j(src, srcPos, dst, dstPos, size) {
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex = srcPos + size | 0;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = src;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    arrayCopy(tmp, dst, dstPos, srcPos, endIndex);
  }
  u2k(src, srcPos, dst, dstPos, size) {
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex = srcPos + size | 0;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = src;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    arrayCopy(tmp, dst, dstPos, srcPos, endIndex);
  }
}
class PointList {}
function get_dimensions() {
  return 2;
}
function isEmpty() {
  return this.e1() === 0;
}
function getX(index) {
  return this.p27(index, 0);
}
function getY(index) {
  return this.p27(index, 1);
}
function get_1(index) {
  return Vector2D.n27(this.p27(index, 0), this.p27(index, 1));
}
function getComponentList(component, out) {
  var inductionVariable = 0;
  var last = this.e1();
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      out[n] = this.p27(n, component);
    }
     while (inductionVariable < last);
  return out;
}
function getComponentList$default(component, out, $super) {
  out = out === VOID ? new Float64Array(this.e1()) : out;
  return $super === VOID ? this.z2q(component, out) : getComponentList(component, out);
}
function get_first() {
  return this.d1(0);
}
function get_last() {
  return this.d1(this.e1() - 1 | 0);
}
function clone(out) {
  out.f2r(this);
  return out;
}
function clone$default(out, $super) {
  out = out === VOID ? new PointArrayList(this.e1()) : out;
  return $super === VOID ? this.b2r(out) : clone(out);
}
class Companion_10 {}
class PointArrayList {
  constructor(capacity) {
    capacity = capacity === VOID ? 7 : capacity;
    this.c2r_1 = new Mixin();
    this.d2r_1 = false;
    this.e2r_1 = DoubleArrayList.j2k(imul(capacity, 2));
  }
  vx(_set____db54di) {
    this.c2r_1.vx(_set____db54di);
  }
  wx() {
    return this.c2r_1.wx();
  }
  e1() {
    return this.e2r_1.e1() / 2 | 0;
  }
  p27(index_0, dim) {
    return this.e2r_1.qx(index(this, index_0, dim));
  }
  k27(index_0) {
    return this.e2r_1.qx(index(this, index_0, 0));
  }
  l27(index_0) {
    return this.e2r_1.qx(index(this, index_0, 1));
  }
  d1(index_0) {
    var i = index(this, index_0, 0);
    return Vector2D.n27(this.e2r_1.qx(i), this.e2r_1.qx(i + 1 | 0));
  }
  zg() {
    this.e2r_1.h3();
    return this;
  }
  h2r(x, y) {
    this.e2r_1.o2k(x, y);
    return this;
  }
  i2r(p) {
    return this.h2r(p.e25_1, p.f25_1);
  }
  j2r(p) {
    return this.k2r(p);
  }
  k2r(p) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.PointArrayList.addAll.<anonymous>' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n = 0;
    while (n < p.e1()) {
      // Inline function 'korlibs.math.geom.PointArrayList.addAll.<anonymous>.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var destruct = p.d1(_unary__edvuaz);
      var x = destruct.fl();
      var y = destruct.gl();
      this.h2r(x, y);
    }
    return this;
  }
  l2r(p, index) {
    this.h2r(p.k27(index), p.l27(index));
  }
  f2r(other) {
    this.zg();
    this.j2r(other);
    return this;
  }
  b2r(out) {
    return out.zg().j2r(this);
  }
  f2k(index_0, count) {
    this.e2r_1.f2k(index(this, index_0, 0), imul(count, 2));
    return this;
  }
  m2r(index, count, $super) {
    count = count === VOID ? 1 : count;
    return $super === VOID ? this.f2k(index, count) : $super.f2k.call(this, index, count);
  }
  equals(other) {
    var tmp;
    if (other instanceof PointArrayList) {
      tmp = this.e2r_1.equals(other.e2r_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return this.e2r_1.hashCode();
  }
  toString() {
    var sb = StringBuilder.f();
    sb.pb(_Char___init__impl__6a9atx(91));
    var inductionVariable = 0;
    var last = this.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var _destruct__k2r9zo = this.d1(n);
        var x = _destruct__k2r9zo.fl();
        var y = _destruct__k2r9zo.gl();
        if (!(n === 0)) {
          sb.ob(', ');
        }
        sb.pb(_Char___init__impl__6a9atx(40));
        if (x === round(x))
          sb.sg(numberToInt(x));
        else
          sb.vg(x);
        sb.ob(', ');
        if (y === round(y))
          sb.sg(numberToInt(y));
        else
          sb.vg(y);
        sb.pb(_Char___init__impl__6a9atx(41));
      }
       while (inductionVariable < last);
    sb.pb(_Char___init__impl__6a9atx(93));
    return sb.toString();
  }
  ax(other, epsilon) {
    return this.q27((!(other == null) ? isInterface(other, IDoubleVectorList) : false) ? other : THROW_CCE(), epsilon);
  }
  x2(elements) {
    return this.i27(elements);
  }
  l1(element) {
    if (!(element instanceof Vector2D))
      return -1;
    return this.g27(element instanceof Vector2D ? element : THROW_CCE());
  }
}
class DoubleVectorArrayList {
  constructor(dimensions, capacity) {
    capacity = capacity === VOID ? 7 : capacity;
    this.n2r_1 = new Mixin();
    this.o2r_1 = dimensions;
    this.p2r_1 = DoubleArrayList.j2k(imul(capacity, this.o2r_1));
    this.q2r_1 = false;
  }
  vx(_set____db54di) {
    this.n2r_1.vx(_set____db54di);
  }
  wx() {
    return this.n2r_1.wx();
  }
  r27() {
    return this.o2r_1;
  }
  e1() {
    return this.p2r_1.e1() / this.o2r_1 | 0;
  }
  p27(index, dim) {
    return this.p2r_1.d1(imul(index, this.o2r_1) + dim | 0);
  }
  o2k(v0, v1) {
    // Inline function 'kotlin.also' call
    checkDimensions(this, 2);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.DoubleVectorArrayList.add.<anonymous>' call
    this.p2r_1.o2k(v0, v1);
    return Unit_instance;
  }
  p2k(v0, v1, v2, v3) {
    // Inline function 'kotlin.also' call
    checkDimensions(this, 4);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.DoubleVectorArrayList.add.<anonymous>' call
    this.p2r_1.p2k(v0, v1, v2, v3);
    return Unit_instance;
  }
  q2k(v0, v1, v2, v3, v4, v5) {
    // Inline function 'kotlin.also' call
    checkDimensions(this, 6);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.DoubleVectorArrayList.add.<anonymous>' call
    this.p2r_1.q2k(v0, v1, v2, v3, v4, v5);
    return Unit_instance;
  }
  r2r(index, out, roundDecimalPlaces) {
    appendGenericArray(out, this.o2r_1, DoubleVectorArrayList$vectorToStringBuilder$lambda(this, index, roundDecimalPlaces));
  }
  equals(other) {
    var tmp;
    var tmp_0;
    if (other instanceof DoubleVectorArrayList) {
      tmp_0 = this.o2r_1 === other.o2r_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.p2r_1.equals(other.p2r_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return this.p2r_1.hashCode();
  }
  toString() {
    return this.s2r(null);
  }
  s2r(roundDecimalPlaces) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.DoubleVectorArrayList.toString.<anonymous>' call
    this_0.ob('VectorArrayList[' + this.e1() + '](\n');
    var inductionVariable = 0;
    var last = this.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(n === 0)) {
          this_0.ob(', \n');
        }
        this_0.ob('   ');
        this.r2r(n, this_0, roundDecimalPlaces);
      }
       while (inductionVariable < last);
    this_0.ob('\n)');
    return this_0.toString();
  }
  h3() {
    this.p2r_1.h3();
  }
  ax(other, epsilon) {
    return this.q27((!(other == null) ? isInterface(other, IDoubleVectorList) : false) ? other : THROW_CCE(), epsilon);
  }
}
class Companion_11 {}
class PointIntArrayList {
  constructor(capacity) {
    capacity = capacity === VOID ? 7 : capacity;
    this.t2r_1 = new Mixin();
    this.u2r_1 = false;
    this.v2r_1 = IntArrayList.n2j(capacity);
    this.w2r_1 = IntArrayList.n2j(capacity);
  }
  vx(_set____db54di) {
    this.t2r_1.vx(_set____db54di);
  }
  wx() {
    return this.t2r_1.wx();
  }
  e1() {
    return this.v2r_1.e1();
  }
  g1() {
    return this.e1() === 0;
  }
  h3() {
    this.v2r_1.h3();
    this.w2r_1.h3();
  }
  x2r(x, y) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.PointIntArrayList.add.<anonymous>' call
    this.v2r_1.w2j(x);
    this.w2r_1.w2j(y);
    return this;
  }
  y2r(p) {
    return this.x2r(p.d2f_1, p.e2f_1);
  }
  k27(index) {
    return this.v2r_1.qx(index);
  }
  l27(index) {
    return this.w2r_1.qx(index);
  }
  toString() {
    var sb = StringBuilder.f();
    sb.pb(_Char___init__impl__6a9atx(91));
    var inductionVariable = 0;
    var last = this.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var x = this.k27(n);
        var y = this.l27(n);
        if (!(n === 0)) {
          sb.ob(', ');
        }
        sb.pb(_Char___init__impl__6a9atx(40));
        sb.sg(x);
        sb.ob(', ');
        sb.sg(y);
        sb.pb(_Char___init__impl__6a9atx(41));
      }
       while (inductionVariable < last);
    sb.pb(_Char___init__impl__6a9atx(93));
    return sb.toString();
  }
}
//endregion
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  return Companion_instance_0;
}
function swap(_this__u8e3s4, lIndex, rIndex) {
  var temp = _this__u8e3s4[lIndex];
  _this__u8e3s4[lIndex] = _this__u8e3s4[rIndex];
  _this__u8e3s4[rIndex] = temp;
}
function rotateRight(_this__u8e3s4, offset) {
  offset = offset === VOID ? 1 : offset;
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure._rotateRight' call
    var size = _this__u8e3s4.length;
    var offset_0 = umod(offset, size);
    if (offset_0 === 0) {
      tmp$ret$0 = Unit_instance;
      break $l$block;
    }
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(1 <= offset_0 ? offset_0 < size : false)) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message = 'Check failed.';
      throw IllegalStateException.w4(toString(message));
    }
    // Inline function 'korlibs.datastructure.rotateRight.<anonymous>' call
    reverse(_this__u8e3s4, 0, size);
    // Inline function 'korlibs.datastructure.rotateRight.<anonymous>' call
    reverse(_this__u8e3s4, 0, offset_0);
    // Inline function 'korlibs.datastructure.rotateRight.<anonymous>' call
    reverse(_this__u8e3s4, offset_0, size);
  }
  return tmp$ret$0;
}
var Companion_instance_1;
function Companion_getInstance_1() {
  return Companion_instance_1;
}
function ensure($this, count) {
  if (($this.b2j_1 + count | 0) > $this.a2j_1.length) {
    var tmp = $this;
    var tmp_0 = $this.a2j_1;
    // Inline function 'kotlin.math.max' call
    var a = $this.b2j_1 + count | 0;
    var b = imul($this.a2j_1.length, 3);
    var tmp$ret$0 = Math.max(a, b);
    var tmp_1 = copyOf(tmp_0, tmp$ret$0);
    tmp.a2j_1 = isFloatArray(tmp_1) ? tmp_1 : THROW_CCE();
  }
}
var Companion_instance_2;
function Companion_getInstance_2() {
  return Companion_instance_2;
}
var Companion_instance_3;
function Companion_getInstance_3() {
  return Companion_instance_3;
}
function ensure_0($this, count) {
  if (($this.i2k_1 + count | 0) > $this.h2k_1.length) {
    var tmp = $this;
    var tmp_0 = $this.h2k_1;
    // Inline function 'kotlin.math.max' call
    var a = $this.i2k_1 + count | 0;
    var b = imul($this.h2k_1.length, 3);
    var tmp$ret$0 = Math.max(a, b);
    var tmp_1 = copyOf_1(tmp_0, tmp$ret$0);
    tmp.h2k_1 = isDoubleArray(tmp_1) ? tmp_1 : THROW_CCE();
  }
}
function intArrayListOf(values) {
  return IntArrayList.r2j(values.slice());
}
function toIntArrayList(_this__u8e3s4) {
  return IntArrayList.r2j(_this__u8e3s4.slice());
}
function floatArrayListOf(values) {
  return FloatArrayList.d2j(values.slice());
}
function doubleArrayListOf(values) {
  return DoubleArrayList.m2k(values.slice());
}
function sort(_this__u8e3s4, start, end, reversed) {
  start = start === VOID ? 0 : start;
  end = end === VOID ? _this__u8e3s4.e1() : end;
  reversed = reversed === VOID ? false : reversed;
  return genericSort_0(_this__u8e3s4, start, end - 1 | 0, DoubleArrayListSortOps_getInstance(), reversed);
}
function reverse_0(_this__u8e3s4, start, end) {
  start = start === VOID ? 0 : start;
  end = end === VOID ? _this__u8e3s4.e1() : end;
  return DoubleArrayListSortOps_getInstance().x2k(_this__u8e3s4, start, end - 1 | 0);
}
var DoubleArrayListSortOps_instance;
function DoubleArrayListSortOps_getInstance() {
  if (DoubleArrayListSortOps_instance === VOID)
    new DoubleArrayListSortOps();
  return DoubleArrayListSortOps_instance;
}
function _get__data__kyoi3c($this) {
  // Inline function 'korlibs.datastructure.fastCastTo' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return $this.f2l_1;
}
function _get_capacity__a9k9f3($this) {
  return $this.f2l_1.length;
}
function resizeIfRequiredFor($this, count) {
  if (($this.e1() + count | 0) > _get_capacity__a9k9f3($this)) {
    var i = $this.f2l_1;
    var istart = $this.d2l_1;
    // Inline function 'kotlin.arrayOfNulls' call
    // Inline function 'kotlin.comparisons.maxOf' call
    var a = $this.f2l_1.length + 7 | 0;
    // Inline function 'kotlin.comparisons.maxOf' call
    var a_0 = $this.e1() + count | 0;
    var b = imul($this.f2l_1.length, 2);
    var b_0 = Math.max(a_0, b);
    var size = Math.max(a, b_0);
    var _o = fillArrayVal(Array(size), null);
    var o = isArray(_o) ? _o : THROW_CCE();
    copyCyclic($this, i, istart, o, $this.e2l_1);
    $this.f2l_1 = o;
    $this.d2l_1 = 0;
  }
}
function copyCyclic($this, i, istart, o, count) {
  // Inline function 'kotlin.math.min' call
  var a = i.length - istart | 0;
  var size1 = Math.min(a, count);
  var size2 = count - size1 | 0;
  Memory_instance.g2l(i, istart, o, 0, size1);
  if (size2 > 0) {
    Memory_instance.g2l(i, 0, o, size1, size2);
  }
}
function _addLast($this, item) {
  $this.f2l_1[($this.d2l_1 + $this.e2l_1 | 0) % _get_capacity__a9k9f3($this) | 0] = item;
  $this.e2l_1 = $this.e2l_1 + 1 | 0;
}
function nullify($this, index) {
  _get__data__kyoi3c($this)[index] = null;
}
function _removeRetainAll($this, elements, retain) {
  var eset = toSet(elements);
  // Inline function 'kotlin.collections.copyOf' call
  // Inline function 'kotlin.js.asDynamic' call
  var _temp = $this.f2l_1.slice();
  var tsize = 0;
  var osize = $this.e1();
  var inductionVariable = 0;
  var last = $this.e1();
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var c = $this.d1(n);
      if (eset.w2(c) === retain) {
        var _unary__edvuaz = tsize;
        tsize = _unary__edvuaz + 1 | 0;
        _temp[_unary__edvuaz] = c;
      }
    }
     while (inductionVariable < last);
  $this.f2l_1 = _temp;
  $this.d2l_1 = 0;
  $this.e2l_1 = tsize;
  return !(tsize === osize);
}
function internalIndex($this, index) {
  return umod($this.d2l_1 + index | 0, _get_capacity__a9k9f3($this));
}
function _get__data__kyoi3c_0($this) {
  // Inline function 'korlibs.datastructure.fastCastTo' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return $this.c2m_1;
}
function _get_capacity__a9k9f3_0($this) {
  return $this.c2m_1.length;
}
function resizeIfRequiredFor_0($this, count) {
  if (($this.e1() + count | 0) > _get_capacity__a9k9f3_0($this)) {
    var i = $this.c2m_1;
    var istart = $this.a2m_1;
    // Inline function 'kotlin.comparisons.maxOf' call
    var a = $this.c2m_1.length + 7 | 0;
    // Inline function 'kotlin.comparisons.maxOf' call
    var a_0 = $this.e1() + count | 0;
    var b = imul($this.c2m_1.length, 2);
    var b_0 = Math.max(a_0, b);
    var tmp$ret$1 = Math.max(a, b_0);
    var _o = new Int32Array(tmp$ret$1);
    var o = isIntArray(_o) ? _o : THROW_CCE();
    copyCyclic_0($this, i, istart, o, $this.b2m_1);
    $this.c2m_1 = o;
    $this.a2m_1 = 0;
  }
}
function copyCyclic_0($this, i, istart, o, count) {
  // Inline function 'kotlin.math.min' call
  var a = i.length - istart | 0;
  var size1 = Math.min(a, count);
  var size2 = count - size1 | 0;
  Memory_instance.z2j(i, istart, o, 0, size1);
  if (size2 > 0) {
    Memory_instance.z2j(i, 0, o, size1, size2);
  }
}
function _addLast_0($this, item) {
  $this.c2m_1[($this.a2m_1 + $this.b2m_1 | 0) % _get_capacity__a9k9f3_0($this) | 0] = item;
  $this.b2m_1 = $this.b2m_1 + 1 | 0;
}
function nullify_0($this, index) {
  _get__data__kyoi3c_0($this)[index] = 0;
}
function internalIndex_0($this, index) {
  return umod($this.a2m_1 + index | 0, _get_capacity__a9k9f3_0($this));
}
function toDeque(_this__u8e3s4) {
  return Deque(_this__u8e3s4);
}
function Deque(other) {
  // Inline function 'kotlin.also' call
  var this_0 = TGenDeque.k2l(other.e1());
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.datastructure.Deque.<anonymous>' call
  this_0.p2l(other);
  return this_0;
}
function getAndRemove(_this__u8e3s4, key) {
  // Inline function 'kotlin.also' call
  var this_0 = get_2(_this__u8e3s4, key);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.datastructure.getAndRemove.<anonymous>' call
  remove(_this__u8e3s4, key);
  return this_0;
}
function get_keys(_this__u8e3s4) {
  return keys(_this__u8e3s4);
}
function translateIndex(_this__u8e3s4, $this) {
  if (!(0 <= _this__u8e3s4 ? _this__u8e3s4 < $this.e1() : false))
    throw IndexOutOfBoundsException.ce('' + _this__u8e3s4);
  return $this.w2m_1 + _this__u8e3s4 | 0;
}
var Companion_instance_4;
function Companion_getInstance_4() {
  return Companion_instance_4;
}
function IArray2$asString$lambda(this$0) {
  return function (y) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = until(0, this$0.m2i());
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var inductionVariable = this_0.a2_1;
    var last = this_0.b2_1;
    if (inductionVariable <= last)
      do {
        var item = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.datastructure.IArray2.asString.<anonymous>.<anonymous>' call
        var x = item;
        var tmp$ret$0 = this$0.t2i(x, y);
        destination.h(tmp$ret$0);
      }
       while (!(item === last));
    return joinToString(destination, ', ');
  };
}
function indexOr(_this__u8e3s4, x, y, invalid) {
  invalid = invalid === VOID ? -1 : invalid;
  if (!(0 <= x ? x < _this__u8e3s4.m2i() : false) || !(0 <= y ? y < _this__u8e3s4.n2i() : false))
    return invalid;
  return imul(y, _this__u8e3s4.m2i()) + x | 0;
}
function currentKey($this) {
  switch ($this.j2n_1) {
    case 2147483647:
    case 2147483646:
      return 0;
    default:
      return $this.i2n_1.s2n_1[$this.j2n_1];
  }
}
function currentValue($this) {
  switch ($this.j2n_1) {
    case 2147483647:
      return $this.i2n_1.p2n_1;
    case 2147483646:
      return null;
    default:
      return $this.i2n_1.t2n_1[$this.j2n_1];
  }
}
function nextNonEmptyIndex($this, keys, offset) {
  var inductionVariable = offset;
  var last = keys.length;
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      if (!(keys[n] === 0))
        return n;
    }
     while (inductionVariable < last);
  return 2147483646;
}
function next($this) {
  if (!($this.j2n_1 === 2147483646))
    $this.j2n_1 = nextNonEmptyIndex($this, $this.i2n_1.s2n_1, $this.j2n_1 === 2147483647 ? 0 : $this.j2n_1 + 1 | 0);
}
function IntMap$_get_keys_$o$iterator$lambda_bn8atq($it) {
  return function () {
    return $it.b1();
  };
}
function IntMap$_get_keys_$o$iterator$lambda_bn8atq_0($it) {
  return function () {
    return $it.w2n();
  };
}
function IntMap$_get_values_$o$iterator$lambda_ggo058($it) {
  return function () {
    return $it.b1();
  };
}
function IntMap$_get_values_$o$iterator$lambda_ggo058_0($it) {
  return function () {
    return $it.x2n();
  };
}
var Companion_instance_5;
function Companion_getInstance_5() {
  return Companion_instance_5;
}
function _get_stashStart__3psegu($this) {
  return $this.s2n_1.length - $this.r2n_1 | 0;
}
function grow($this) {
  var inc = $this.l2n_1 < 20 ? 3 : 1;
  var newnbits = $this.l2n_1 + inc | 0;
  var new_0 = IntMap.b2o(newnbits, $this.m2n_1, true);
  var inductionVariable = 0;
  var last = $this.s2n_1.length - 1 | 0;
  if (inductionVariable <= last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var k = $this.s2n_1[n];
      if (!(k === 0)) {
        new_0.c2o(k, $this.t2n_1[n]);
      }
    }
     while (inductionVariable <= last);
  $this.l2n_1 = new_0.l2n_1;
  $this.n2n_1 = new_0.n2n_1;
  $this.q2n_1 = new_0.q2n_1;
  $this.r2n_1 = new_0.r2n_1;
  $this.s2n_1 = new_0.s2n_1;
  $this.t2n_1 = new_0.t2n_1;
  $this.u2n_1 = new_0.u2n_1;
}
function growStash($this) {
  $this.r2n_1 = imul($this.r2n_1, 2);
  $this.s2n_1 = copyOf_0($this.s2n_1, $this.d2o());
  $this.t2n_1 = copyOf_2($this.t2n_1, $this.d2o());
}
function _getKeyIndex($this, key) {
  if (key === 0)
    return $this.o2n_1 ? 2147483647 : -1;
  var index1 = hash1($this, key);
  if ($this.s2n_1[index1] === key)
    return index1;
  var index2 = hash2($this, key);
  if ($this.s2n_1[index2] === key)
    return index2;
  var index3 = hash3($this, key);
  if ($this.s2n_1[index3] === key)
    return index3;
  var inductionVariable = _get_stashStart__3psegu($this);
  var last = $this.s2n_1.length;
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      if ($this.s2n_1[n] === key)
        return n;
    }
     while (inductionVariable < last);
  return -1;
}
function setEmptySlot($this, index, key, value) {
  if (!($this.s2n_1[index] === 0))
    throw IllegalStateException.n5();
  $this.s2n_1[index] = key;
  $this.t2n_1[index] = value;
  $this.v2n_1 = $this.v2n_1 + 1 | 0;
  return null;
}
function hash1($this, key) {
  return _hash1(key, $this.q2n_1);
}
function hash2($this, key) {
  return _hash2(key, $this.q2n_1);
}
function hash3($this, key) {
  return _hash3(key, $this.q2n_1);
}
var Companion_instance_6;
function Companion_getInstance_6() {
  return Companion_instance_6;
}
function _get_stashStart__3psegu_0($this) {
  return $this.u2o_1.length - $this.t2o_1 | 0;
}
function grow_0($this) {
  var inc = $this.n2o_1 < 20 ? 3 : 1;
  var newnbits = $this.n2o_1 + inc | 0;
  var new_0 = IntIntMap.y2o(newnbits, $this.o2o_1, true);
  var inductionVariable = 0;
  var last = $this.u2o_1.length - 1 | 0;
  if (inductionVariable <= last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var k = $this.u2o_1[n];
      if (!(k === 0)) {
        new_0.z2o(k, $this.v2o_1[n]);
      }
    }
     while (inductionVariable <= last);
  $this.n2o_1 = new_0.n2o_1;
  $this.p2o_1 = new_0.p2o_1;
  $this.s2o_1 = new_0.s2o_1;
  $this.t2o_1 = new_0.t2o_1;
  $this.u2o_1 = new_0.u2o_1;
  $this.v2o_1 = new_0.v2o_1;
  $this.w2o_1 = new_0.w2o_1;
}
function growStash_0($this) {
  $this.t2o_1 = imul($this.t2o_1, 2);
  $this.u2o_1 = copyOf_0($this.u2o_1, $this.d2o());
  $this.v2o_1 = copyOf_0($this.v2o_1, $this.d2o());
}
function _getKeyIndex_0($this, key) {
  if (key === 0)
    return $this.q2o_1 ? 2147483647 : -1;
  var index1 = hash1_0($this, key);
  if ($this.u2o_1[index1] === key)
    return index1;
  var index2 = hash2_0($this, key);
  if ($this.u2o_1[index2] === key)
    return index2;
  var index3 = hash3_0($this, key);
  if ($this.u2o_1[index3] === key)
    return index3;
  var inductionVariable = _get_stashStart__3psegu_0($this);
  var last = $this.u2o_1.length;
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      if ($this.u2o_1[n] === key)
        return n;
    }
     while (inductionVariable < last);
  return -1;
}
function setEmptySlot_0($this, index, key, value) {
  if (!($this.u2o_1[index] === 0))
    throw IllegalStateException.n5();
  $this.u2o_1[index] = key;
  $this.v2o_1[index] = value;
  $this.x2o_1 = $this.x2o_1 + 1 | 0;
  return 0;
}
function hash1_0($this, key) {
  return _hash1(key, $this.s2o_1);
}
function hash2_0($this, key) {
  return _hash2(key, $this.s2o_1);
}
function hash3_0($this, key) {
  return _hash3(key, $this.s2o_1);
}
function toIntMap(_this__u8e3s4) {
  var out = IntMap.i2o(numberToInt(_this__u8e3s4.e1() * 1.25));
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s = _this__u8e3s4.p1().a1();
  while (_iterator__ex2g4s.b1()) {
    var _destruct__k2r9zo = _iterator__ex2g4s.c1();
    // Inline function 'kotlin.collections.component1' call
    var k = _destruct__k2r9zo.q1();
    // Inline function 'kotlin.collections.component2' call
    var v = _destruct__k2r9zo.r1();
    out.c2o(k, v);
  }
  return out;
}
function _hash1(key, mask) {
  return _mask(key, mask);
}
function _hash2(key, mask) {
  return _mask(imul(key, 1294968109), mask);
}
function _hash3(key, mask) {
  return _mask(imul(key, 294969449), mask);
}
function _mask(value, mask) {
  return (((value + ((value >>> 8 | 0) & 255) | 0) + ((value >>> 16 | 0) & 255) | 0) + (value >> 24 & 255) | 0) & mask;
}
function associateByInt(_this__u8e3s4, block) {
  var n = 0;
  var out = IntMap.i2o();
  var _iterator__ex2g4s = _this__u8e3s4.a1();
  while (_iterator__ex2g4s.b1()) {
    var it = _iterator__ex2g4s.c1();
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    out.c2o(block(_unary__edvuaz, it), it);
  }
  return out;
}
function Iterator_0(hasNext, next) {
  return new Iterator$1(hasNext, next);
}
var Companion_instance_7;
function Companion_getInstance_7() {
  return Companion_instance_7;
}
function Pool$_init_$lambda_q3cbhr(it) {
  return Unit_instance;
}
function Pool$_init_$lambda_q3cbhr_0(it) {
  return Unit_instance;
}
function ConcurrentPool$_init_$lambda_gqhtk8(it) {
  return Unit_instance;
}
function ReturnablePool$_init_$lambda_rsm60r(it) {
  return Unit_instance;
}
function ReturnablePool$list$lambda(this$0) {
  return function (it) {
    this$0.x2p_1(it);
    return Unit_instance;
  };
}
function ReturnablePool$list$lambda_0(this$0) {
  return function (it) {
    return this$0.y2p_1(it);
  };
}
var Companion_instance_8;
function Companion_getInstance_8() {
  return Companion_instance_8;
}
function _set_value__lx0xdg(_this__u8e3s4, $this, value) {
  $this.h2q_1[_PriorityQueueNode___get_index__impl__b6r7i5(_this__u8e3s4)] = value;
}
function _get_value__a43j40(_this__u8e3s4, $this) {
  return $this.h2q_1[_PriorityQueueNode___get_index__impl__b6r7i5(_this__u8e3s4)];
}
function _get_isRoot__1006zj(_this__u8e3s4, $this) {
  return _PriorityQueueNode___get_index__impl__b6r7i5(_this__u8e3s4) === 0;
}
function _get_parent__oo9xup(_this__u8e3s4, $this) {
  return _PriorityQueueNode___init__impl__34dlfu((_PriorityQueueNode___get_index__impl__b6r7i5(_this__u8e3s4) - 1 | 0) / 2 | 0);
}
function _get_left__d9qyp0(_this__u8e3s4, $this) {
  return _PriorityQueueNode___init__impl__34dlfu(imul(2, _PriorityQueueNode___get_index__impl__b6r7i5(_this__u8e3s4)) + 1 | 0);
}
function _get_right__bvz45n(_this__u8e3s4, $this) {
  return _PriorityQueueNode___init__impl__34dlfu(imul(2, _PriorityQueueNode___get_index__impl__b6r7i5(_this__u8e3s4)) + 2 | 0);
}
function gt($this, a, b) {
  return $this.i2q_1.compare(a, b) > 0;
}
function lt($this, a, b) {
  return $this.i2q_1.compare(a, b) < 0;
}
function _get_capacity__a9k9f3_1($this) {
  return $this.h2q_1.length;
}
function ensure_1($this, index) {
  if (index >= _get_capacity__a9k9f3_1($this)) {
    var tmp = $this;
    var tmp_0 = copyOf_2($this.h2q_1, 2 + imul(_get_capacity__a9k9f3_1($this), 2) | 0);
    tmp.h2q_1 = isArray(tmp_0) ? tmp_0 : THROW_CCE();
  }
}
function minHeapify($this, index) {
  var i = _PriorityQueueNode___init__impl__34dlfu(index);
  $l$loop: while (true) {
    var left = _get_left__d9qyp0(i, $this);
    var right = _get_right__bvz45n(i, $this);
    var smallest = i;
    if (_PriorityQueueNode___get_index__impl__b6r7i5(left) < $this.j2q_1 && lt($this, _get_value__a43j40(left, $this), _get_value__a43j40(i, $this)))
      smallest = left;
    if (_PriorityQueueNode___get_index__impl__b6r7i5(right) < $this.j2q_1 && lt($this, _get_value__a43j40(right, $this), _get_value__a43j40(smallest, $this)))
      smallest = right;
    if (!(smallest === i)) {
      swap_0($this, i, smallest);
      i = smallest;
    } else {
      break $l$loop;
    }
  }
}
function swap_0($this, l, r) {
  var temp = _get_value__a43j40(r, $this);
  _set_value__lx0xdg(r, $this, _get_value__a43j40(l, $this));
  _set_value__lx0xdg(l, $this, temp);
}
function _PriorityQueueNode___init__impl__34dlfu(index) {
  return index;
}
function _PriorityQueueNode___get_index__impl__b6r7i5($this) {
  return $this;
}
function Ref(value) {
  // Inline function 'kotlin.also' call
  var this_0 = Ref_0();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.datastructure.Ref.<anonymous>' call
  this_0.s2q(value);
  return this_0;
}
function toRef(_this__u8e3s4) {
  return Ref_1(_this__u8e3s4);
}
function Ref_0() {
  return new Ref$1();
}
function Ref_1(prop) {
  return new Ref$2(prop);
}
function _TGenStack___init__impl__yynjgt(items) {
  items = items === VOID ? FastArrayList.ny() : items;
  return items;
}
function _get_items__fzd5gv($this) {
  return $this;
}
function _TGenStack___get_size__impl__cvg66t($this) {
  return _get_items__fzd5gv($this).e1();
}
function TGenStack__isEmpty_impl_bsbpyi($this) {
  return _TGenStack___get_size__impl__cvg66t($this) === 0;
}
var Companion_instance_9;
function Companion_getInstance_9() {
  return Companion_instance_9;
}
function TGenStack__push_impl_9yh33t($this, v) {
  _get_items__fzd5gv($this).h(v);
}
function TGenStack__pop_impl_qisxa0($this) {
  return _get_items__fzd5gv($this).l3(_get_items__fzd5gv($this).e1() - 1 | 0);
}
function TGenStack__clear_impl_pali4s($this) {
  _get_items__fzd5gv($this).h3();
}
function TGenStack__containsAll_impl_ic9i7r($this, elements) {
  return _get_items__fzd5gv($this).x2(elements);
}
function TGenStack__containsAll_impl_ic9i7r_0($this, elements) {
  return TGenStack__containsAll_impl_ic9i7r($this.v2q_1, elements);
}
function TGenStack__iterator_impl_2pdia5($this) {
  return _get_items__fzd5gv($this).a1();
}
function TGenStack__toString_impl_s9t5hn($this) {
  return 'TGenStack(items=' + $this.toString() + ')';
}
function TGenStack__hashCode_impl_l04zom($this) {
  return $this.hashCode();
}
function TGenStack__equals_impl_w9i35u($this, other) {
  if (!(other instanceof TGenStack))
    return false;
  var tmp0_other_with_cast = other instanceof TGenStack ? other.v2q_1 : THROW_CCE();
  if (!$this.equals(tmp0_other_with_cast))
    return false;
  return true;
}
function contentHashCode_2(_this__u8e3s4, src, dst) {
  // Inline function 'korlibs.datastructure.internal.hashCoder' call
  var count = dst - src | 0;
  var out = 0;
  var inductionVariable = 0;
  if (inductionVariable < count)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      out = imul(out, 7);
      var tmp = out;
      // Inline function 'korlibs.datastructure.internal.contentHashCode.<anonymous>' call
      out = tmp + toRawBits(_this__u8e3s4[src + n | 0]) | 0;
    }
     while (inductionVariable < count);
  return out;
}
function contentEquals_2(_this__u8e3s4, that, src, dst) {
  var tmp$ret$1;
  $l$block: {
    // Inline function 'korlibs.datastructure.internal.equaler' call
    var count = dst - src | 0;
    var inductionVariable = 0;
    if (inductionVariable < count)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.datastructure.internal.contentEquals.<anonymous>' call
        if (!(_this__u8e3s4[src + n | 0] === that[src + n | 0])) {
          tmp$ret$1 = false;
          break $l$block;
        }
      }
       while (inductionVariable < count);
    tmp$ret$1 = true;
  }
  return tmp$ret$1;
}
function contentHashCode_3(_this__u8e3s4, src, dst) {
  // Inline function 'korlibs.datastructure.internal.hashCoder' call
  var count = dst - src | 0;
  var out = 0;
  var inductionVariable = 0;
  if (inductionVariable < count)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      out = imul(out, 7);
      var tmp = out;
      // Inline function 'korlibs.datastructure.internal.contentHashCode.<anonymous>' call
      out = tmp + _this__u8e3s4[src + n | 0] | 0;
    }
     while (inductionVariable < count);
  return out;
}
function contentEquals_3(_this__u8e3s4, that, src, dst) {
  var tmp$ret$1;
  $l$block: {
    // Inline function 'korlibs.datastructure.internal.equaler' call
    var count = dst - src | 0;
    var inductionVariable = 0;
    if (inductionVariable < count)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.datastructure.internal.contentEquals.<anonymous>' call
        if (!(_this__u8e3s4[src + n | 0] === that[src + n | 0])) {
          tmp$ret$1 = false;
          break $l$block;
        }
      }
       while (inductionVariable < count);
    tmp$ret$1 = true;
  }
  return tmp$ret$1;
}
function contentHashCode_4(_this__u8e3s4, src, dst) {
  // Inline function 'korlibs.datastructure.internal.hashCoder' call
  var count = dst - src | 0;
  var out = 0;
  var inductionVariable = 0;
  if (inductionVariable < count)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      out = imul(out, 7);
      var tmp = out;
      // Inline function 'korlibs.datastructure.internal.contentHashCode.<anonymous>' call
      out = tmp + numberToInt(_this__u8e3s4[src + n | 0]) | 0;
    }
     while (inductionVariable < count);
  return out;
}
function contentEquals_4(_this__u8e3s4, that, src, dst) {
  var tmp$ret$1;
  $l$block: {
    // Inline function 'korlibs.datastructure.internal.equaler' call
    var count = dst - src | 0;
    var inductionVariable = 0;
    if (inductionVariable < count)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.datastructure.internal.contentEquals.<anonymous>' call
        if (!(_this__u8e3s4[src + n | 0] === that[src + n | 0])) {
          tmp$ret$1 = false;
          break $l$block;
        }
      }
       while (inductionVariable < count);
    tmp$ret$1 = true;
  }
  return tmp$ret$1;
}
function fill(_this__u8e3s4, value) {
  var inductionVariable = 0;
  var last = _this__u8e3s4.length - 1 | 0;
  if (inductionVariable <= last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      _this__u8e3s4[n] = value;
    }
     while (inductionVariable <= last);
}
function linkedHashMapOf(pairs) {
  // Inline function 'kotlin.also' call
  var this_0 = LinkedHashMap.bc();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.datastructure.linkedHashMapOf.<anonymous>' call
  var inductionVariable = 0;
  var last = pairs.length;
  while (inductionVariable < last) {
    var _destruct__k2r9zo = pairs[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    var key = _destruct__k2r9zo.fl();
    var value = _destruct__k2r9zo.gl();
    // Inline function 'kotlin.collections.set' call
    this_0.e3(key, value);
  }
  return this_0;
}
function _BSearchResult___init__impl__em6zam(raw) {
  return raw;
}
function _BSearchResult___get_raw__impl__uyuhf3($this) {
  return $this;
}
function _BSearchResult___get_found__impl__om04iz($this) {
  return _BSearchResult___get_raw__impl__uyuhf3($this) >= 0;
}
function _BSearchResult___get_index__impl__b5kraz($this) {
  return _BSearchResult___get_found__impl__om04iz($this) ? _BSearchResult___get_raw__impl__uyuhf3($this) : -1;
}
function _BSearchResult___get_nearIndex__impl__s8nq43($this) {
  return _BSearchResult___get_found__impl__om04iz($this) ? _BSearchResult___get_raw__impl__uyuhf3($this) : (-_BSearchResult___get_raw__impl__uyuhf3($this) | 0) - 1 | 0;
}
function binarySearch(_this__u8e3s4, v, fromIndex, toIndex) {
  fromIndex = fromIndex === VOID ? 0 : fromIndex;
  toIndex = toIndex === VOID ? _this__u8e3s4.e1() : toIndex;
  // Inline function 'korlibs.datastructure.genericBinarySearchResult' call
  var tmp$ret$1;
  $l$block: {
    // Inline function 'korlibs.datastructure.genericBinarySearch' call
    var low = fromIndex;
    var high = toIndex - 1 | 0;
    while (low <= high) {
      var mid = (low + high | 0) / 2 | 0;
      // Inline function 'korlibs.datastructure.binarySearch.<anonymous>' call
      var mval = compareTo(_this__u8e3s4.qx(mid), v);
      if (mval < 0)
        low = mid + 1 | 0;
      else if (mval > 0)
        high = mid - 1 | 0;
      else {
        tmp$ret$1 = mid;
        break $l$block;
      }
    }
    // Inline function 'korlibs.datastructure.genericBinarySearchResult.<anonymous>' call
    tmp$ret$1 = (-low | 0) - 1 | 0;
  }
  return _BSearchResult___init__impl__em6zam(tmp$ret$1);
}
function getCyclic(_this__u8e3s4, index) {
  return _this__u8e3s4.d1(umod(index, _this__u8e3s4.e1()));
}
function getCyclicOrNull(_this__u8e3s4, index) {
  return _this__u8e3s4.g1() ? null : getOrNull(_this__u8e3s4, umod(index, _this__u8e3s4.e1()));
}
function toLinkedMap(_this__u8e3s4) {
  // Inline function 'kotlin.also' call
  var this_0 = LinkedHashMap.bc();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.datastructure.toLinkedMap.<anonymous>' call
  var _iterator__ex2g4s = _this__u8e3s4.a1();
  while (_iterator__ex2g4s.b1()) {
    var _destruct__k2r9zo = _iterator__ex2g4s.c1();
    var key = _destruct__k2r9zo.fl();
    var value = _destruct__k2r9zo.gl();
    // Inline function 'kotlin.collections.set' call
    this_0.e3(key, value);
  }
  return this_0;
}
function getCyclic_0(_this__u8e3s4, index) {
  return _this__u8e3s4[umod(index, _this__u8e3s4.length)];
}
function genericSort(subject, left, right, ops) {
  return genericSort_0(subject, left, right, ops, false);
}
function genericSort_0(subject, left, right, ops, reversed) {
  // Inline function 'kotlin.also' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.datastructure.genericSort.<anonymous>' call
  timSort(subject, left, right, ops, reversed);
  return subject;
}
function timSort(arr, l, r, ops, reversed, RUN) {
  RUN = RUN === VOID ? 32 : RUN;
  var n = (r - l | 0) + 1 | 0;
  var progression = step(until(0, n), RUN);
  var inductionVariable = progression.a2_1;
  var last = progression.b2_1;
  var step_0 = progression.c2_1;
  if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + step_0 | 0;
      var tmp = l + i | 0;
      // Inline function 'kotlin.math.min' call
      var a = (i + RUN | 0) - 1 | 0;
      var b = n - 1 | 0;
      var tmp$ret$0 = Math.min(a, b);
      insertionSort(arr, tmp, l + tmp$ret$0 | 0, ops, reversed);
    }
     while (!(i === last));
  var size = RUN;
  while (size < n) {
    var progression_0 = step(until(0, n), imul(2, size));
    var inductionVariable_0 = progression_0.a2_1;
    var last_0 = progression_0.b2_1;
    var step_1 = progression_0.c2_1;
    if (step_1 > 0 && inductionVariable_0 <= last_0 || (step_1 < 0 && last_0 <= inductionVariable_0))
      do {
        var left = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + step_1 | 0;
        // Inline function 'kotlin.math.min' call
        var a_0 = size;
        var b_0 = (n - left | 0) - 1 | 0;
        var rize = Math.min(a_0, b_0);
        var mid = (left + rize | 0) - 1 | 0;
        // Inline function 'kotlin.math.min' call
        var a_1 = (left + imul(2, rize) | 0) - 1 | 0;
        var b_1 = n - 1 | 0;
        var right = Math.min(a_1, b_1);
        merge(arr, l + left | 0, l + mid | 0, l + right | 0, ops, reversed);
      }
       while (!(left === last_0));
    size = imul(size, 2);
  }
}
function insertionSort(arr, left, right, ops, reversed) {
  var inductionVariable = left + 1 | 0;
  if (inductionVariable <= right)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var m = n - 1 | 0;
      $l$loop: while (m >= left && negateIf(ops.z2k(arr, m, n), reversed) > 0) {
        m = m - 1 | 0;
      }
      m = m + 1 | 0;
      if (!(m === n)) {
        ops.c2l(arr, m, n);
      }
    }
     while (!(n === right));
}
function merge(arr, start, mid, end, ops, reversed) {
  var s = start;
  var m = mid;
  var s2 = m + 1 | 0;
  if (negateIf(ops.z2k(arr, m, s2), reversed) <= 0)
    return Unit_instance;
  while (s <= m && s2 <= end) {
    if (negateIf(ops.z2k(arr, s, s2), reversed) <= 0) {
      s = s + 1 | 0;
    } else {
      ops.c2l(arr, s, s2);
      s = s + 1 | 0;
      m = m + 1 | 0;
      s2 = s2 + 1 | 0;
    }
  }
}
function negateIf(_this__u8e3s4, doNegate) {
  return doNegate ? -_this__u8e3s4 | 0 : _this__u8e3s4;
}
var Memory_instance;
function Memory_getInstance() {
  return Memory_instance;
}
var Companion_instance_10;
function Companion_getInstance_10() {
  return Companion_instance_10;
}
function index($this, index, offset) {
  return imul(index, 2) + offset | 0;
}
function pointArrayListOf(p0, p1) {
  return (new PointArrayList(2)).i2r(p0).i2r(p1);
}
function pointArrayListOf_0(p0, p1, p2) {
  return (new PointArrayList(3)).i2r(p0).i2r(p1).i2r(p2);
}
function pointArrayListOf_1(p0, p1, p2, p3) {
  return (new PointArrayList(4)).i2r(p0).i2r(p1).i2r(p2).i2r(p3);
}
function checkDimensions($this, dim) {
  if (!(dim === $this.o2r_1)) {
    // Inline function 'kotlin.error' call
    var message = 'Invalid dimensions ' + dim + ' != ' + $this.o2r_1;
    throw IllegalStateException.w4(toString(message));
  }
}
function DoubleVectorArrayList$vectorToStringBuilder$lambda(this$0, $index, $roundDecimalPlaces) {
  return function ($this$appendGenericArray, it) {
    var v = this$0.p27($index, it);
    appendNice($this$appendGenericArray, !($roundDecimalPlaces == null) ? roundDecimalPlaces(v, $roundDecimalPlaces) : v);
    return Unit_instance;
  };
}
var Companion_instance_11;
function Companion_getInstance_11() {
  return Companion_instance_11;
}
function FastStringMap() {
  // Inline function 'kotlin.js.asDynamic' call
  return new Map();
}
function FastIntMap() {
  // Inline function 'kotlin.js.asDynamic' call
  return new Map();
}
function get_size(_this__u8e3s4) {
  // Inline function 'kotlin.js.asDynamic' call
  return _this__u8e3s4.size;
}
function FastIdentityMap() {
  // Inline function 'kotlin.js.asDynamic' call
  return new Map();
}
function contains(_this__u8e3s4, key) {
  // Inline function 'kotlin.js.asDynamic' call
  return _this__u8e3s4.has(key);
}
function clear(_this__u8e3s4) {
  // Inline function 'kotlin.js.asDynamic' call
  _this__u8e3s4.clear();
}
function get_size_0(_this__u8e3s4) {
  // Inline function 'kotlin.js.asDynamic' call
  return _this__u8e3s4.size;
}
function get_2(_this__u8e3s4, key) {
  // Inline function 'kotlin.js.asDynamic' call
  return _this__u8e3s4.get(key);
}
function set_1(_this__u8e3s4, key, value) {
  // Inline function 'kotlin.js.asDynamic' call
  _this__u8e3s4.set(key, value);
}
function remove(_this__u8e3s4, key) {
  // Inline function 'kotlin.js.asDynamic' call
  _this__u8e3s4.delete(key);
}
function keys(_this__u8e3s4) {
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = Array_from(_this__u8e3s4.keys());
  return toList_0(tmp$ret$2);
}
function Array_from(value) {
  return Array.from(value);
}
//region block: post-declaration
initMetadataForCompanion(Companion);
initMetadataForInterface(IArray2, 'IArray2', VOID, VOID, [Iterable]);
initMetadataForInterface(IntIArray2, 'IntIArray2', VOID, VOID, [IArray2]);
protoOf(IntArray2).p27 = get;
protoOf(IntArray2).s2i = set;
protoOf(IntArray2).qx = getAt_0;
protoOf(IntArray2).t2i = getAt;
protoOf(IntArray2).u2i = inside;
protoOf(IntArray2).r2i = asString;
initMetadataForClass(IntArray2, 'IntArray2', VOID, VOID, [IntIArray2]);
initMetadataForCompanion(Companion_0);
initMetadataForInterface(FloatIArray2, 'FloatIArray2', VOID, VOID, [IArray2]);
protoOf(FloatArray2).p27 = get_0;
protoOf(FloatArray2).z2i = set_0;
protoOf(FloatArray2).qx = getAt_1;
protoOf(FloatArray2).t2i = getAt;
protoOf(FloatArray2).u2i = inside;
protoOf(FloatArray2).r2i = asString;
initMetadataForClass(FloatArray2, 'FloatArray2', VOID, VOID, [FloatIArray2]);
initMetadataForCompanion(Companion_1);
initMetadataForClass(FloatArrayList, 'FloatArrayList', FloatArrayList.c2j, VOID, [Collection]);
initMetadataForCompanion(Companion_2);
initMetadataForClass(IntArrayList, 'IntArrayList', IntArrayList.n2j, VOID, [Collection]);
initMetadataForCompanion(Companion_3);
protoOf(DoubleArrayList).y2 = listIterator;
initMetadataForClass(DoubleArrayList, 'DoubleArrayList', DoubleArrayList.j2k, VOID, [DoubleList]);
initMetadataForClass(SortOps, 'SortOps');
initMetadataForObject(DoubleArrayListSortOps, 'DoubleArrayListSortOps');
initMetadataForClass(TGenDeque$iterator$1);
initMetadataForClass(TGenDeque, 'TGenDeque', TGenDeque.l2l, VOID, [MutableIterable, Collection]);
initMetadataForClass(IntDeque$iterator$1);
initMetadataForClass(IntDeque, 'IntDeque', IntDeque.h2m, VOID, [MutableIterable, Collection]);
initMetadataForClass(FastSmallSet, 'FastSmallSet', FastSmallSet.s2m);
initMetadataForClass(GenericSubList, 'GenericSubList', VOID, VOID, [KtList]);
initMetadataForClass(GenericListIterator, 'GenericListIterator');
initMetadataForClass(HistoryStack, 'HistoryStack', HistoryStack);
initMetadataForCompanion(Companion_4);
initMetadataForCompanion(Companion_5);
initMetadataForClass(Entry, 'Entry');
initMetadataForClass(Iterator, 'Iterator');
initMetadataForClass(_no_name_provided__qut3iv, VOID, VOID, VOID, [Iterable]);
initMetadataForClass(_no_name_provided__qut3iv_0, VOID, VOID, VOID, [Iterable]);
initMetadataForClass(IntMap, 'IntMap', IntMap.i2o);
initMetadataForCompanion(Companion_6);
initMetadataForClass(IntIntMap, 'IntIntMap', IntIntMap.a2p);
initMetadataForClass(Iterator$1);
initMetadataForCompanion(Companion_7);
initMetadataForClass(Pool, 'Pool');
initMetadataForClass(ConcurrentPool, 'ConcurrentPool');
initMetadataForClass(ReturnablePool, 'ReturnablePool');
initMetadataForClass(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForCompanion(Companion_8);
initMetadataForClass(TGenPriorityQueue$iterator$1);
initMetadataForClass(TGenPriorityQueue, 'TGenPriorityQueue', VOID, VOID, [MutableIterable, Collection]);
initMetadataForClass(TGenQueue, 'TGenQueue', TGenQueue, VOID, [Collection]);
initMetadataForClass(Ref$1);
initMetadataForClass(Ref$2);
initMetadataForCompanion(Companion_9);
initMetadataForClass(TGenStack, 'TGenStack', VOID, VOID, [Collection]);
initMetadataForClass(SyncPauseable, 'SyncPauseable', SyncPauseable);
initMetadataForObject(Memory, 'Memory');
initMetadataForInterface(PointList, 'PointList', VOID, VOID, [IDoubleVectorList, IPointList]);
initMetadataForCompanion(Companion_10);
protoOf(PointArrayList).g2r = clone$default;
protoOf(PointArrayList).r27 = get_dimensions;
protoOf(PointArrayList).g1 = isEmpty;
protoOf(PointArrayList).z2q = getComponentList;
protoOf(PointArrayList).a2r = getComponentList$default;
protoOf(PointArrayList).r2l = get_first;
protoOf(PointArrayList).s2l = get_last;
protoOf(PointArrayList).o27 = isNotEmpty;
protoOf(PointArrayList).q27 = isAlmostEquals;
protoOf(PointArrayList).bx = isAlmostEquals$default;
protoOf(PointArrayList).i27 = containsAll;
protoOf(PointArrayList).g27 = indexOf;
protoOf(PointArrayList).a1 = iterator;
protoOf(PointArrayList).y2 = listIterator_0;
protoOf(PointArrayList).i1 = listIterator_1;
protoOf(PointArrayList).z2 = subList;
initMetadataForClass(PointArrayList, 'PointArrayList', PointArrayList, VOID, [PointList]);
protoOf(DoubleVectorArrayList).q27 = isAlmostEquals;
protoOf(DoubleVectorArrayList).bx = isAlmostEquals$default;
initMetadataForClass(DoubleVectorArrayList, 'DoubleVectorArrayList', VOID, VOID, [IDoubleVectorList]);
initMetadataForCompanion(Companion_11);
initMetadataForClass(PointIntArrayList, 'PointIntArrayList', PointIntArrayList);
//endregion
//region block: init
Companion_instance = new Companion();
Companion_instance_0 = new Companion_0();
Companion_instance_1 = new Companion_1();
Companion_instance_2 = new Companion_2();
Companion_instance_3 = new Companion_3();
Companion_instance_4 = new Companion_4();
Companion_instance_5 = new Companion_5();
Companion_instance_6 = new Companion_6();
Companion_instance_7 = new Companion_7();
Companion_instance_8 = new Companion_8();
Companion_instance_9 = new Companion_9();
Memory_instance = new Memory();
Companion_instance_10 = new Companion_10();
Companion_instance_11 = new Companion_11();
//endregion
//region block: exports
export {
  _BSearchResult___init__impl__em6zam as _BSearchResult___init__impl__em6zam3kgjdixysmohf,
  _BSearchResult___get_found__impl__om04iz as _BSearchResult___get_found__impl__om04iz3bh6o9yjop0o,
  _BSearchResult___get_index__impl__b5kraz as _BSearchResult___get_index__impl__b5kraz2d2rlh08ytgci,
  _BSearchResult___get_nearIndex__impl__s8nq43 as _BSearchResult___get_nearIndex__impl__s8nq431w00iur5bsqs2,
  _TGenStack___init__impl__yynjgt as _TGenStack___init__impl__yynjgt2kqnbzr6sil9y,
  TGenStack__pop_impl_qisxa0 as TGenStack__pop_impl_qisxa01c9hqlgdxaps5,
  TGenStack__push_impl_9yh33t as TGenStack__push_impl_9yh33t21dxxdiycat5m,
  Companion_instance_0 as Companion_instance3ldriv9x4zcjm,
  Companion_instance as Companion_instancelqpzd9anuk16,
  Companion_instance_8 as Companion_instance2r8kc48nhvjcq,
  SyncPauseable as SyncPauseable20rt0nt3umu2s,
  ConcurrentPool as ConcurrentPool3ky1e4r5za9ab,
  DoubleArrayList as DoubleArrayList3by0we6lhx26x,
  FastIdentityMap as FastIdentityMap17d14y8i3m5g7,
  FastIntMap as FastIntMapl0pzyavg6uw5,
  FastSmallSet as FastSmallSet2og2j8v2pz4c7,
  FastStringMap as FastStringMap1l1uzdhsfbatm,
  FloatArray2 as FloatArray2beehiaucxmzd,
  GenericListIterator as GenericListIterator397gjg9p2xwl5,
  GenericSubList as GenericSubList2rec7qqyf06nw,
  HistoryStack as HistoryStack2mrikkhc0etuj,
  IntArray2 as IntArray23680o40e0fgt8,
  IntArrayList as IntArrayList3liuagbdnwmna,
  IntDeque as IntDeque2ebok66x2sofm,
  IntIntMap as IntIntMap3mvg5iqgd5t3z,
  IntMap as IntMap2d9g6f5pyaoc2,
  Pool as Pool1zbsw0zhvh8ca,
  Ref_0 as Ref11k43t82thcp3,
  Ref as Ref2y4j4snnxo6gs,
  ReturnablePool as ReturnablePool3rkgvxsckx2u2,
  SortOps as SortOps3rp25tm4jbjru,
  TGenDeque as TGenDeque2zx9g0ftfbw19,
  TGenQueue as TGenQueue2v9j3ju90xgpv,
  associateByInt as associateByInt3vmv30txx5avl,
  binarySearch as binarySearch1lxbagta5e4q4,
  clear as clear3idbm40uzyume,
  contains as containsrsn76oa0puwr,
  doubleArrayListOf as doubleArrayListOfkj3z9zq4pobs,
  floatArrayListOf as floatArrayListOfa8snvg2p0fhc,
  genericSort as genericSort3vhmyxbppxo3h,
  getAndRemove as getAndRemove1ksxnnren48mb,
  getCyclicOrNull as getCyclicOrNull12fem85bj0m7u,
  getCyclic_0 as getCyclic18d9063nmuul,
  getCyclic as getCyclic28wvgqye98jqx,
  get_2 as get2pw1zlgv5zypd,
  intArrayListOf as intArrayListOf18h0hna7wb0zr,
  get_keys as get_keyswqddktl7cnu2,
  linkedHashMapOf as linkedHashMapOf2w2uhgrq4khrk,
  reverse_0 as reverse22fe0u1pwl2c6,
  rotateRight as rotateRight96vk8nw2c6nx,
  set_1 as set2vuztm9k7ubgo,
  get_size_0 as get_size2tttv7g2u748n,
  get_size as get_size3oaoh8cpamcqc,
  sort as sort23bpsawysis6n,
  swap as swap3upf401qn4fc8,
  toDeque as toDeque2gx2crptp8sro,
  toIntArrayList as toIntArrayList3jlt4o6tyleu,
  toIntMap as toIntMapp1jij98esrcm,
  toRef as toRef3av6zm8yavumw,
  DoubleVectorArrayList as DoubleVectorArrayListq54dfthnqi2t,
  PointArrayList as PointArrayList281mrsgyr6ua1,
  PointIntArrayList as PointIntArrayList1s7gare9hr1oh,
  pointArrayListOf_1 as pointArrayListOf36sb9r6prgwk4,
  pointArrayListOf_0 as pointArrayListOf2s9je3njyg83l,
  pointArrayListOf as pointArrayListOf7rbgdbqf3x4b,
};
//endregion
